export default {
    address: {
        city: "Şehir",
        city_locality: "Şehir \/ Mahalle",
        country: "Ülke",
        line1: "Adres satırı 1",
        line2: "Adres Satırı 2",
        postal_code: "Posta Kodu",
        state: "Eyalet",
        state_region: "Eyalet \/ Bölge"
    },
    alerts: {
        account_2fa: "Hesabınızı iki faktörlü kimlik doğrulamasıyla güvence altına alın.",
        account_2fa_success: "İki faktörlü kimlik doğrulama etkin.",
        activate_instruction: "Otomatik değerlendirme toplamayı açtığınızda {count} için bir değerlendirme talep etmeye çalışılacaktır. Etkinleştirmeden önce şablonlarınızı görüntüleyin.",
        activate_intro: "Stratejinize göre sürekli olarak değerlendirme talep edin.",
        agency_mcp_server: "Claude'u veya herhangi bir MCP istemcisini kurumunuzun MCP sunucusuna bağlayın. Yetkilendirilmiş asistanlar, kurumunuzun projelerini, müşterilerini ve ekibini sizin adınıza yönetebilir.",
        agency_sso: "İstemci girişi için bir OpenID Connect kimlik sağlayıcısı bağlayın.",
        ai_assistant: "AI'nın yorum önerileri ve yanıtları için kullanılabilmesi için işletmenizin adı ve açıklamasının girilmesi zorunludur.",
        api_key_roll: "API anahtarınızı değiştirmek istediğinizden emin misiniz? Bu değişiklik, onu kullanan tüm uygulamaları etkileyecektir.",
        ask_confirm: "{count} müşteriden değerlendirme talep etmek istediğinizden emin misiniz? Bu, henüz sorulmamış tüm müşteriler için istekleri planlayacaktır.",
        cname_delete: "CNAME: {cname_name}'yi kaldırmak istediğinizden emin misiniz?",
        cname_not_configured: "Bu kayıt henüz yapılandırılmadı. Lütfen bekleyin...",
        cname_warning: "Müşterilerinize daha önce gönderilmiş mesajların bağlantıları bozuk olacaktır.",
        connection_disabled: "Bağlantı devre dışı. Lütfen tekrar bağlanın.",
        customer_archive: "Müşteriyi arşivlemek istediğinizden emin misiniz: {customer_name}? Gönderilmemiş tüm mesajlar iptal edilecektir.",
        customer_cancel: "{customer_name} adlı müşteriye ait gönderilmemiş tüm mesajları iptal etmek istediğinizden emin misiniz?",
        customer_ingest: "Müşterilerinize e-posta gönderirken bu e-posta adresini BCC alanına ekleyin; böylece müşterileriniz otomatik olarak adlarını ve e-posta adreslerini içe aktarabilir.",
        customer_resubscribe: "{customer_name} müşterisini yeniden abone etmek istediğinizden emin misiniz?",
        customer_unarchive: "Müşteriyi arşivden çıkarmak istediğinizden emin misiniz: {customer_name}?",
        customer_unsubscribe: "{customer_name} isimli müşterinin aboneliğini iptal etmek istediğinizden emin misiniz?",
        customer_unsubscribe_all: "{count} müşterinin bu projeden mesaj almasını durdurmak istediğinizden emin misiniz?",
        delete: "{model}: {name} öğesini silmek istediğinizden emin misiniz?",
        delete_count: "{count} öğesini silmek istediğinizden emin misiniz?",
        domain_agency: "Ajansınızı tamamen beyaz etiketli hale getirmek için kendi gönderme alan adınızı ekleyin.",
        domain_delete: "{name} alan adını kaldırmak istediğinizden emin misiniz? Kendi alan adımızdan e-posta göndermeye devam edeceğiz.",
        domain_dmarc: "E-postalarınızın spam klasörüne düşme olasılığını azaltmak için alan adınıza bir DMARC kaydı ekleyin.",
        domain_project: "Müşterilerinize kendi alan adınızdan e-posta gönderebilmemiz için bir gönderici alan adı ekleyin.",
        export_confirm: "{model}'inizin tamamını dışa aktarmak istediğinizden emin misiniz?",
        export_count: "{count}'u dışa aktarmak istediğinizden emin misiniz?",
        export_link: "İsteğinizi yaptıktan kısa bir süre sonra {email} adresine bir indirme bağlantısı gönderilecektir.",
        highlights_save_disabled: "İsteğe bağlı olarak, şu anda vurgu içeren tüm değerlendirmeler vurguları kaldırabilirsiniz.",
        highlights_save_enabled: "Tüm olumlu değerlendirmeler için öne çıkan bölümler oluşturmak için aşağıdaki kutuyu işaretleyin. Yalnızca öne çıkan bölümün rengini değiştiriyorsanız, kutuyu işaretlemeyin.",
        integration_disconnect: "{integration_name} ile olan bağlantınızı kesmek istediğinizden emin misiniz?",
        integration_sync: "{integration_name} hesabınızı senkronize etmek istediğinizden emin misiniz? Verilerinizi sizin için sürekli olarak içe aktaracağız.",
        intro: "Müşterilerinizden daha fazla olumlu değerlendirmeler almak için hazır mısınız? Başlamak için müşterilerinizi içe aktarın. Ardından değerlendirmeler manuel olarak isteyin veya Otomatikleştir düğmesine basın ve değerlendirmeler gelmesini bekleyin.",
        logout: "Çıkış yapmak istediğinize emin misiniz?",
        mcp_server: "Claude'u veya herhangi bir MCP istemcisini bu projeye bağlayın. MCP sunucu, yapay zeka asistanlarının sizin adınıza değerlendirmeler, müşterileri ve mesajları okumasını ve yönetmesini sağlar.",
        member_confirm: "Kendinizi kaldırmak istediğinizden emin misiniz? Bu projeye erişiminizi kaybedeceksiniz.",
        member_confirm_all: "Kendinizi kaldırmak istediğinizden emin misiniz? Tüm projelerinize erişiminizi kaybedeceksiniz.",
        member_other_confirm: "{noun}: {name} öğesini kaldırmak istediğinizden emin misiniz? Bu projeye erişimlerini kaybedecekler.",
        member_other_confirm_all: "{noun} {name}'yı kaldırmak istediğinizden emin misiniz? Tüm projelerine erişimlerini kaybedecekler.",
        message_cancel: "Bu mesajı iptal etmek istediğinizden emin misiniz?",
        message_cancel_all: "{count}'yi iptal etmek istediğinizden emin misiniz? Bu eylem yalnızca gönderilmemiş mesajlarda gerçekleştirilebilir.",
        message_delete: "Bu mesajı silmek istediğinizden emin misiniz?",
        oauth_client_revoke: "{client} için erişimi iptal etmek istediğinizden emin misiniz? Aktif tüm oturumlar derhal sonlandırılacaktır.",
        project_summary: "Şu anda bir özet oluşturulamıyor.",
        project_suspend: "{project_name} projesini askıya almak istediğinizden emin misiniz?",
        project_unsuspend: "{project_name} projesinin askıya alınmasını kaldırmak istediğinizden emin misiniz?",
        review_delete: "Bu değerlendirmeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
        review_page_confirm: "Değişikliklerinizi kaydetmek istediğinizden emin misiniz?",
        review_page_confirmation: "Seçilen puana göre başarı sayfasında bir onay mesajı gösterin.",
        review_page_default: "Değerlendirme sayfasını {name} varsayılan sayfanız yapmak istediğinizden emin misiniz? Değerlendirme isteğine başka bir sayfa atanmamışsa bu sayfa kullanılacaktır.",
        review_page_delete: "Değerlendirme sayfasını silmek istediğinizden emin misiniz: {name}? Şu anda bu sayfaya yönlendirilen tüm müşteriler varsayılan sayfanıza yönlendirilecektir.",
        review_page_delete_all: "{count}'yi silmek istediğinizden emin misiniz? Varsayılan değerlendirme sayfanız silinmeyecek.",
        review_page_fields: "Müşteri yorum bıraktığında müşteri bilgilerini yakalamak için alanları kullanın. Formunuza daha fazla alan ekleyin ve müşteriler bir derecelendirme seçtiğinde bunları koşullu olarak görüntüleyin.",
        review_page_instructions: "Bir derecelendirme seçildikten sonra talimatları doğrudan formun üstünde göster.",
        review_page_location_picker: "Müşterilerin projenizde değerlendirme için herhangi bir konumu seçmesine izin verin. Değerlendirme sayfasının belirli bir konum için gösterilmesi amaçlanıyorsa bu önceden seçilecektir.",
        review_page_locations: "Bu değerlendirme sayfasını kullanması gereken konumları seçin. Bir konum yalnızca bir değerlendirme sayfasına atanabilir. Bir konuma bir konum atanmamışsa, varsayılan değerlendirme sayfasını kullanacaktır.",
        review_page_redirects: "Bir derecelendirme seçildikten sonra formu atlayın ve başka bir yere yönlendirin. Ayrıca, her derecelendirme için birden fazla yönlendirme ekleyerek trafiği birden fazla web sitesine bölebilirsiniz.",
        share_template_delete: "\"{name}\" paylaşım şablonunu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
        smtp_remove: "SMTP yapılandırmasını projenizden kaldırmak istediğinizden emin misiniz? Gönderen etki alanınız standart yapılandırmaya geri dönecektir.",
        smtp_setup: "Kendi posta sunucunuzdan e-posta gönderin. SMTP kimlik bilgilerinizi girin. Sunucunuz IP kısıtlamaları kullanıyorsa, lütfen sistemimiz tarafından kullanılan şu IP'leri beyaz listeye ekleyin: {ips}.",
        space_delete: "{name} çalışma alanını silmek istediğinizden emin misiniz? İçindeki tüm projeler silinecektir.",
        tag_rule: "Olumlu bir terim ve onun olumsuz karşılığını ekleyin. Eğer geçerliyse, değerlendirmeyi otomatik olarak biriyle veya diğeriyle etiketlemek için AI kullanacağız.",
        user_delete: "{email} kullanıcı hesabını silmek istediğinizden emin misiniz?",
        user_verify: "E-posta adresinizi doğrulamak ve hesabınızı etkinleştirmek için {email} adresine gönderilen e-postadaki bağlantıya tıklayın.",
        widget_delete: "Widget'ı silmek istediğinizden emin misiniz: {name}? Widget artık hiçbir web sitesinde görüntülenmeyecek.",
        widget_restore: "Widget: {name} için ayarları geri yüklemek istediğinizden emin misiniz? Yalnızca tasarım varsayılan değerlere geri dönecektir.",
        widgets_1: "Bu betiği web sitenizin body bölümüne ekleyin.",
        widgets_2: "Değerlendirme duvarı tüm değerlendirmelerinizi ızgara şeklinde gösterir. Bu betiği widget'ın görüntülenmesini istediğiniz yere ekleyin.",
        widgets_3: "Öne çıkan değerlendirme tek bir büyük değerlendirme gösterir. Bu betiği widget'ın görüntülenmesini istediğiniz yere ekleyin."
    },
    billing_statuses: {
        active: "Aboneliğiniz aktif durumda.",
        canceled: "Aboneliğiniz iptal edildi. Devam etmek için lütfen aboneliğinizi yenileyin.",
        ending: "Aboneliğiniz {date} tarihinde sona eriyor.",
        trial: "Ücretsiz deneme süreniz {date} tarihinde sona eriyor.",
        trial_expired: "Ücretsiz deneme süreniz sona erdi. Devam etmek için lütfen yükseltme yapın.",
        trial_expiring: "Ücretsiz deneme süreniz yakında sona erecek. Devam etmek için lütfen yükseltme yapın."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-posta",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messenger",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "E-posta adresinizi düzenlemek için bir gönderen alan adı ekleyin:",
        agency_robots: "Arama motorlarının müşteri portalınızı indekslemesine izin verin.",
        ai_business_description: "Değerlendirme önerileri ve yanıtları üretmeye yardımcı olmak için işletmenizin ayrıntılı bir açıklaması.",
        ai_business_name: "İşletmenizin adı.",
        ask_location: "Değerlendirmeye atanacak yer.",
        ask_review_page: "Değerlendirmeyi yakalamak için sayfa.",
        assign_tags: "Yorumlara etiketler atayın.",
        csv_max_rows: "{count} Satıra Kadar",
        dashboard_configure_settings: "Proje ayarlarınızı yapılandırın.",
        dashboard_import_customers: "Müşterilerinizi içe aktarın.",
        dashboard_preview_email_templates: "E-posta şablonlarınızın önizlemesini yapın.",
        dashboard_preview_kiosk_page: "Kiosk sayfanızın önizlemesini görüntüleyin.",
        dashboard_preview_review_page: "Değerlendirme sayfanızı önizleyin.",
        dashboard_preview_showcase_page: "Showcase sayfanızın önizlemesini yapın.",
        logo_height: "E-postalarda ve sayfalarda logonun yüksekliği.",
        meta_description: "Sayfa açıklamasını geçersiz kıl.",
        meta_title: "Sayfa başlığını geçersiz kıl.",
        mfa_password: "Hesap şifrenizi giriniz.",
        mfa_qr_code: "QR kodunu kimlik doğrulama uygulamanızla tarayın.",
        mfa_security_code: "Kimlik doğrulama uygulamanızdaki kodu girin.",
        override_ambassador: "Müşterilerinizin e-postalarında, sayfalarında ve widget'larında bir rozet gösterin.",
        project_name: "İşletmenizin, markanızın veya web sitenizin adı.",
        project_robots: "Arama motorlarının değerlendirme sayfalarınızı ve vitrininizi indekslemesine izin verin.",
        project_slug: "CNAME yapılandırılmamışsa müşteriye yönelik e-postalarda ve bağlantılarda kullanılır.",
        review_page_copied_message: "Olumlu bir değerlendirme gönderildikten sonra gösterilir.",
        review_page_email_address: "Bu e-postada yorumları alın.",
        review_page_link_reveal_position: "Bağlantıların nerede gösterileceği.",
        review_page_link_revealer_label: "Bağlantıları ortaya çıkaran etiket.",
        review_page_link_revealer_rating: "Müşteri bu puanı veya daha yüksek bir puanı seçerse bağlantıları göster, aksi takdirde bunları göstermek için bir düğme göster.",
        review_page_native_reviews: "Bu platformda değerlendirmelere izin verin.",
        review_page_rating_selection: "Değerlendirme gönderilmeden önce puanı kaydedin.",
        review_page_success_button_link: "Boş bırakılırsa bağlantı varsayılan olarak projenizin web sitesine yönlendirilir, aksi takdirde sayfanın alan adı yönlendirilir.",
        review_page_warning: "Müşterilerin herkese açık yorum bırakmasını engellemek, işletmenizin listelenmesinin kaldırılmasına neden olabilir.",
        review_reply_status: "Bu yoruma herkese açık bir şekilde yanıt veremiyoruz. Bunun yerine doğrudan yorumcuyla iletişime geçebilirsiniz.",
        review_suggestions: "Müşterilerin yorum yazmalarına yardımcı olun.",
        separate_with_commas: "Birden fazla olanı virgülle ayırın.",
        setup_basics: "Müşterilerden ne zaman ve nasıl değerlendirme isteyeceğinizi ayarlayın.",
        setup_business: "Müşterilerinizin sizi tanıdığı ismi bize söyleyin.",
        setup_google: "Müşterileri Google profilinize yönlendirin, değerlendirmeler yanıt verin ve mevcut yorumları içe aktarın. Bunu atlayıp daha sonra da yapabilirsiniz.",
        setup_location_limit: "Deneme sürümünüz 1 konum içerir. Daha fazla konumu senkronize etmek için istediğiniz zaman yükseltme yapın.",
        showcase_locations: "Sergiyi belirli yerlerle sınırlayın.",
        showcase_review_length: "Değerlendirmeler en az bu kadar karakterler uzunluğunda olması gerekiyor.",
        showcase_since: "Bu tarihte veya daha önce oluşturulan yorumları göster.",
        showcase_sources: "Showcasei belirli kaynaklarla sınırlayın.",
        showcase_tags: "Vitrini belirli etiketlere sahip değerlendirmelerle sınırlayın.",
        signature_html: "İmzayı kopyalayıp e-posta uygulamanıza yapıştırın.",
        signed_up: "Müşterinin başlangıç tarihi.",
        twilio_webhook: "Mesajlaşma servisiniz için geri arama URL olarak ayarlayın.",
        widget_embed: "Widget'ın görüntüleneceği div kabının ID niteliği."
    },
    labels: {
        accept_all: "Tümünü Kabul Et",
        access_code: "Erişim Kodu",
        access_codes: "Erişim Kodları",
        account: "Hesap",
        account_sid: "Hesap SID",
        action: "Aksiyon",
        actions: "Eylemler",
        activate: "Etkinleştir",
        active: "Aktif",
        add: "Eklemek",
        add_agency_project: "Bir Ajans Projesi Ekle",
        add_confirmation_message: "Onay mesajı ekleyin.",
        add_css_rules: "Kendi css kurallarınızı ekleyin.",
        add_custom_field: "Özel Alan Ekle",
        add_customer: "Müşteri Ekle",
        add_customers_with: "{model} ile Müşteri Ekle",
        add_external_link: "Harici Bağlantı Ekle",
        add_external_links: "Harici Bağlantılar Ekle",
        add_introduction: "Bir giriş ekleyin.",
        add_js_tags: "Kendi JavaScript etiketlerinizi ekleyin.",
        add_legal_information: "Yasal bilgileri ekleyin.",
        add_location: "Konum Ekle",
        add_project: "Proje Ekle",
        add_review: "Değerlendirme Ekle",
        add_source: "Kaynak Ekle",
        add_tag: "Etiket Ekle",
        added: "Eklendi",
        address: "Adres",
        advanced_review_pages: "Gelişmiş Değerlendirme sayfaları",
        affiliates: "Ortaklar",
        age_of_reviews: "Değerlendirmeler Yaşı",
        agencies: "Acenteler",
        agency: "Acente",
        agency_name: "Acente Adı",
        agency_project: "Ajans Projesi",
        agency_projects: "Ajans Projeleri",
        ai: "Yapay zeka",
        ai_answers: "AI Yanıtları",
        ai_assistant: "AI Asistanı",
        ai_auto_tagging: "Yapay Zeka Otomatik Etiketleme",
        ai_reviews_and_replies: "Yapay zeka değerlendirme önerileri ve yanıtları",
        ai_tagging_instructions: "Örnek: Bekleme sürelerinden, yavaş hizmetten veya gecikmelerden bahseden değerlendirmeler uygulayın.",
        all: "Tüm",
        allowed_domains: "İzin Verilen Alan Adları",
        amount: "Miktar",
        analytics: "Analitik",
        and: "Ve",
        anonymous_reviews: "Anonim Değerlendirmeler",
        answer: "Cevap",
        any: "Herhangi",
        api: "API",
        api_key: "API Anahtarı",
        appearance: "Dış görünüş",
        approved: "Onaylı",
        archive: "Arşiv",
        archive_customer: "Arşiv Müşterisi",
        archived: "Arşivlendi",
        at_least: "en azından",
        at_least_days: "En az {num} gün",
        at_least_hours: "En az {num} saat",
        at_least_months: "En az {num} ay",
        at_most: "en fazla",
        at_most_days: "En fazla {num} gün",
        at_most_hours: "En fazla {num} saat",
        at_most_months: "En fazla {num} ay",
        auth_token: "Kimlik Doğrulama Jetonu",
        authorize: "Yetkilendirmek",
        auto_detect: "Otomatik Algılama",
        auto_tags: "Otomatik Etiketler",
        automate: "Otomatikleştirmek",
        automate_highlights: "Vurguları otomatikleştir",
        automate_replies: "Yanıtları Otomatikleştir",
        automatic_review_collection: "Otomatik Değerlendirme Toplama",
        automatically_apply_tags: "Mevcut değerlendirmeler otomatik olarak etiket uygula.",
        automating: "Otomasyon",
        avatar: "Avatar",
        avatars: "Avatarlar",
        average_charge: "Ortalama Ücret",
        average_review: "Ortalama Değerlendirme",
        background_color: "Arkaplan Rengi",
        background_image: "Arkaplan Görüntüsü",
        back: "Geri",
        bcc: "BCC",
        bcc_email_address: "BCC E-posta Adresi",
        best_to_worst: "En iyiden en kötüye",
        billing: "Faturalama",
        blog: "Blog",
        body: "Metin",
        body_font_size: "Metin Yazı Tipi Boyutu",
        bold: "Kalın",
        book_a_demo: "Demo rezervasyonu",
        bottom: "Alt",
        bottom_left: "Sol Alt",
        bottom_right: "Sağ Alt",
        build_on: "{model} üzerine kurun",
        business: "Business",
        business_description: "İş Tanımı",
        business_email: "Destek E-posta Adresi",
        business_name: "İşletme Adı",
        business_phone: "Destek Telefon Numarası",
        business_website: "İşletme Web Sitesi",
        button: "Düğme",
        button_label: "Düğme için etiket",
        button_link: "Düğme Bağlantı",
        button_position: "Düğme Konumu",
        button_size: "Düğme boyutu",
        buy_me_a_coffee: "Bana bir kahve ısmarla",
        by: "ile",
        by_signing_up: "Hesap oluşturarak şartlarımızı kabul etmiş olursunuz.",
        call_to_action: "Eyleme Çağrı",
        cancel: "İptal etmek",
        cancel_1_message: "1 Mesajı İptal Et",
        cancel_message: "Mesajı İptal Et",
        cancel_messages: "{count} Mesajlarını İptal Et",
        cancel_subscription: "Aboneliği İptal Et",
        cancel_unsent_messages: "Gönderilmemiş Mesajları İptal Et",
        canceled: "İptal edildi",
        center: "Merkez",
        change: "Değiştirmek",
        change_key: "API Anahtarınızı Değiştirin",
        change_plan: "Planı Değiştir",
        changelog: "Değişiklik Günlüğü",
        channel: "Kanal",
        channels: "Kanallar",
        characters: "Karakterler",
        charges_avg: "Ortalama ücret en azından şu kadar olmalıdır:",
        charges_count: "Ücretlendirme sayısı en az olmalıdır",
        charges_sum: "Toplam ücretler en azından şu kadar olmalıdır:",
        chat_with_us: "Bizimle sohbet edin",
        checkbox: "Onay kutusu",
        claude: "Claude",
        clear: "Temizlemek",
        clear_highlights_from_reviews: "Tüm değerlendirmeler öne çıkan noktaları kaldır",
        clicked: "Tıklandı",
        client: "Client",
        client_id: "Client ID",
        clients: "Müşteriler",
        close: "Kapalı",
        cloudflare_warning: "Cloudflare kullanıyorsanız proxy'nizin kapalı olması gerekir.",
        cname: "CNAME",
        cname_setup_incomplete: "Kurulum tamamlanmadı - {date} sürümünde kaldırılacaktır.",
        cname_ssl_pending: "SSL sertifikası bekleniyor",
        cname_status_for: "CNAME durumu için",
        code_editor: "Kod Editörü",
        collapse: "Daralt",
        collect_reviews_anywhere: "Herhangi bir yerden değerlendirmeler toplayın.",
        color: "Renk",
        colors: "Renkler",
        commission_rate: "Komisyon Oranı",
        commission_status_approved: "Onaylı",
        commission_status_paid: "Ödendi",
        commission_status_pending: "Askıda olması",
        commission_status_reversed: "Tersine çevrilmiş",
        community: "Toplum",
        company: "Şirket",
        complained: "Şikayet edildi",
        confirm_new_password: "Yeni Şifreyi Onayla",
        confirmation_message: "Onay Mesajı",
        connect: "Bağlamak",
        connect_bank: "Banka Hesabınızı Bağlayın",
        connect_google: "Google ile bağlantı kurun",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Bağlı",
        consent_preferences: "Onay Tercihleri",
        contact_customer: "Müşteriyle İletişime Geçin",
        contact_form: "İletişim Formu",
        contact_support: "Lütfen destek ekibiyle iletişime geçin.",
        contact_us: "Bize Ulaşın",
        container_element: "Konteyner Elemanı",
        context: "Bağlam",
        continue: "Devam etmek",
        continue_with_google: "Google ile devam edin",
        cookie_category_analytics: "Analitik",
        cookie_category_essential: "Gerekli",
        cookie_category_functional: "İşlevsel",
        cookie_category_marketing: "Pazarlama",
        cookie_consent_banner: "Çerez Onayı Bannerı",
        cookie_consent_scope_all: "Herkese göster",
        cookie_consent_scope_eea: "Yalnızca Avrupa Ekonomik Alanı ve Birleşik Krallık ziyaretçilerine göster",
        cookie_consent_scope_none: "Gösterme",
        cookie_policy: "Çerez Politikası",
        cookie_preference: "Çerez Tercihi",
        copied: "Kopyalandı",
        copied_message: "Kopyalanan Mesaj",
        copy: "Kopyala",
        copy_embed_code: "Kopyala Gömme Kodu",
        copy_signature: "İmza Kopyası",
        copy_source_code: "Kaynak kodunu kopyala",
        copy_to_all_ratings: "Tüm puanlara kopyala",
        copy_uuid: "UUID kopyala",
        create: "Yaratmak",
        create_account: "Hesap oluşturmak",
        create_agency: "Bir Ajans Oluşturun",
        create_cname: "Bir CNAME kaydı oluşturun ve bunu şuraya yönlendirin:",
        create_external_link: "Harici Bağlantı Oluştur",
        create_field: "Bir Alan Oluştur",
        create_link: "Bağlantı Oluştur",
        create_location: "Konum Oluştur",
        create_project: "Bir Proje Oluşturun",
        create_qr_code: "QR Kod Oluştur",
        create_review: "Bir Değerlendirme oluşturun",
        create_review_page: "Bir Değerlendirme sayfası Oluşturun",
        create_signature: "İmza Oluştur",
        create_source: "Kaynak Oluştur",
        create_space: "Bir çalışma alanı oluşturun",
        create_tag: "Etiket Oluştur",
        create_tag_rule: "Etiket Kuralı Oluştur",
        create_webhook: "Webhook Oluştur",
        create_widget: "Bir Widget Oluşturun",
        crms: "CRM'ler",
        csv: "CSV",
        currency: "Para birimi",
        current_plan: "Mevcut Plan",
        current_year: "Mevcut Yıl",
        custom_field: "Özel Alan",
        custom_instructions: "Özel Talimatlar",
        custom_url: "Özel URL",
        customer: "Müşteri",
        customer_name_convention: "Müşteri adı biçimi",
        customer_reviews: "Müşteri Değerlendirmeler",
        customers: "Müşteriler",
        customize: "Özelleştirmek",
        customize_review_page: "Değerlendirme sayfası Özelleştir",
        daily: "Günlük",
        daily_email_requests: "Günlük E-posta İstekleri",
        daily_limit: "Günlük Limit",
        daily_requests: "Günlük İstekler",
        daily_sms_requests: "Günlük SMS İstekleri",
        dark: "Karanlık",
        dashboard: "Kontrol paneli",
        date: "Tarih",
        date_added: "Eklenme Tarihi",
        date_canceled: "İptal Tarihi",
        date_clicked: "Tıklanan Tarih",
        date_complained: "Şikayet Tarihi",
        date_delivered: "Teslim Tarihi",
        date_failed: "Tarih Başarısız",
        date_messaged: "Mesajın Gönderildiği Tarih",
        date_opened: "Açılış Tarihi",
        date_replied: "Cevap Tarihi",
        date_requested: "Talep Edilen Tarih",
        date_reviewed: "Değerlendirildi Tarih",
        date_scheduled: "Tarih Planlandı",
        date_sent: "Gönderilen Tarih",
        date_signed_up: "Kayıt Tarihi",
        date_updated: "Güncelleme Tarihi",
        dates: "Tarihler",
        day: "Gün",
        days: "Günler",
        days_after_last_request: "son istekten sonraki günler",
        days_later: "günler sonra",
        deactivate: "Devre dışı bırak",
        default: "Varsayılan",
        default_language: "Varsayılan Dil",
        default_review_page: "Varsayılan Değerlendirme sayfası",
        default_review_visibility: "Varsayılan Değerlendirme Görünürlüğü",
        default_tone: "Varsayılan Ton",
        delay: "Gecikme",
        delete: "Silmek",
        delete_1_customer: "1 Müşteriyi Sil",
        delete_1_review: "1 Değerlendirme Sil",
        delete_1_review_page: "1 Değerlendirme sayfası Sil",
        delete_1_widget: "1 Widget'ı Sil",
        delete_agency: "Ajansı Sil",
        delete_custom_field: "Özel Alanı Sil",
        delete_customer: "Müşteriyi Sil",
        delete_customers: "Müşterileri Sil",
        delete_external_link: "Harici Bağlantı Sil",
        delete_field: "Alanı Sil",
        delete_link: "Bağlantı Sil",
        delete_location: "Konumu Sil",
        delete_message: "Mesajı Sil",
        delete_n_customers: "{count} Müşterilerini Sil",
        delete_n_review_pages: "{count} Değerlendirme sayfaları Sil",
        delete_n_reviews: "{count} Değerlendirmeler Sil",
        delete_n_widgets: "{count} Widget'larını Sil",
        delete_project: "Projeyi Sil",
        delete_qr_code: "QR kodunu sil",
        delete_reply: "Yanıtı Sil",
        delete_review: "Değerlendirme Sil",
        delete_review_page: "Değerlendirme sayfası Sil",
        delete_review_pages: "Değerlendirme sayfaları Sil",
        delete_reviews: "Değerlendirmeler Sil",
        delete_signature: "İmza Sil",
        delete_source: "Kaynak Sil",
        delete_space: "Çalışma Alanını Sil",
        delete_tag: "Etiket Sil",
        delete_tag_rule: "Etiket Kuralını Sil",
        delete_template: "Şablonu Sil",
        delete_user: "Kullanıcıyı Sil",
        delete_webhook: "Webhook'u Sil",
        delete_widget: "Widget'ı Sil",
        delete_widgets: "Widget'ları Sil",
        deleted: "Silindi",
        delivered: "Teslim edilmiş",
        description: "Tanım",
        deselect_all: "Tümünü Seçimden Çıkar",
        disable: "Devre dışı bırakmak",
        disable_automatic_review_collection: "Otomatik Değerlendirme İşlemini Devre Dışı Bırak",
        disable_field: "Alanı devre dışı bırak",
        disable_when_links_are_visible: "Bağlantılar görünür olduğunda devre dışı bırak",
        disabled: "Devre dışı",
        disconnect: "Bağlantıyı kes",
        disconnect_integration: "Bağlantıyı Kesme Entegrasyonu",
        discord_community: "Discord Topluluğu",
        display_name: "Ekran adı",
        dmarc: "DMARC",
        dmarc_status_for: "DMARC durumu için",
        do_not_hide_from_public: "Halktan Gizlenmeyin",
        do_not_send: "Göndermeyin",
        docs: "Belgeler",
        documentation: "Belgeleme",
        domain: "Alan adı",
        domain_name: "Alan Adı",
        dont_have_an_account: "Hesabınız yok mu?",
        dont_send_thanks: "Teşekkür göndermeyin",
        download: "İndirmek",
        download_records: "Kayıtları İndir",
        download_template: "Şablonu İndir",
        dpa: "DPA",
        dsar: "DSAR",
        duplicate: "Kopyalamak",
        duplicate_project: "Projeyi Kopyala",
        duplicate_review_page: "Yinelenen Değerlendirme sayfası",
        duplicate_reviews: "Çift Değerlendirmeler",
        duplicate_widget: "Widget'ı Kopyala",
        edit: "Düzenlemek",
        edit_1_customer: "Düzenle 1 Müşteri",
        edit_1_review: "Düzenle 1 Değerlendirme",
        edit_client: "Client Düzenle",
        edit_custom_field: "Özel Alanı Düzenle",
        edit_customer: "Müşteriyi Düzenle",
        edit_customers: "Müşterileri Düzenle",
        edit_field: "Alanı Düzenle",
        edit_link: "Bağlantı Düzenle",
        edit_location: "Konumu Düzenle",
        edit_member: "Üyeyi Düzenle",
        edit_n_customers: "Müşterileri Düzenle {count}",
        edit_n_reviews: "{count} Değerlendirmeler Düzenle",
        edit_notes: "Düzenleme Notları",
        edit_qr_code: "QR Kodunu Düzenle",
        edit_reviews: "Değerlendirmeler Düzenle",
        edit_signature: "İmza Düzenle",
        edit_source: "Kaynak düzenleme",
        edit_strategy: "Düzenleme Stratejisi",
        edit_tag: "Etiket Düzenle",
        edit_tag_rule: "Etiket Kuralını Düzenle",
        edit_tags: "Etiketleri düzenle",
        edit_team_member: "Editör Ekip Üyesi",
        edit_visibility: "Görünürlüğü Düzenle",
        edit_webhook: "Webhook'u Düzenle",
        editable_ratings: "Düzenlenebilir Derecelendirmeler",
        earned: "Kazanıldı",
        eligible: "Hak sahibi",
        email: "E-posta",
        email_address: "E-posta Adresi",
        email_validation_invalid: "E-posta doğrulaması başarısız oldu",
        email_validation_passed: "E-posta doğrulaması geçti",
        email_validation_unknown: "E-posta doğrulanamadı",
        emails: "E-postalar",
        embed_code: "Gömülü Kod",
        enable: "Olanak vermek",
        enable_automatic_review_collection: "Otomatik Değerlendirme İşlemini Etkinleştir",
        enable_for_all_reviews: "Tüm değerlendirmeler için etkinleştir",
        enable_for_positive_reviews: "Olumlu yorumlar için etkinleştir",
        enable_on_review_pages: "Değerlendirme sayfalarında etkinleştir",
        enabled: "Etkinleştirilmiş",
        end: "Son",
        ends: "Bitişler",
        exclude: "Hariç tutmak",
        exclude_email: "E-postayı hariç tut",
        exclude_sms: "SMS hariç tut",
        excluded_channels: "Hariç tutulan kanallar",
        expand: "Genişletmek",
        expired: "Günü geçmiş",
        export: "Dışa aktar",
        export_1_customer: "1 Müşteriyi Dışa Aktar",
        export_1_review: "1 Değerlendirme Dışa Aktar",
        export_all: "Tümünü Dışa Aktar",
        export_all_customers: "Tüm Müşterileri Dışa Aktar",
        export_all_reviews: "Tüm Değerlendirmeler Dışa Aktar",
        export_customers: "Müşterileri dışa aktar",
        export_n_customers: "Müşterileri Dışa Aktar {count}",
        export_n_reviews: "Dışa Aktar {count} Değerlendirmeler",
        export_reviews: "Değerlendirmeleri dışa aktar",
        external_link: "Dış Bağlantı",
        external_links: "Dış Bağlantılar",
        extra_locations: "Ek Konumlar",
        faces: "Yüzler",
        failed: "Arızalı",
        feedback: "Geri bildirim",
        field: "Alan",
        fields: "Alanlar",
        filter: "Filtre",
        first: "Birinci",
        first_charged: "İlk tahsilat",
        first_name: "İlk adı",
        first_name_last_initial: "Ad, Soyadın Baş Harfi",
        flag_as_duplicate: "Yinelenen Olarak İşaretle",
        font: "Yazı tipi",
        font_family: "Yazı Tipi Ailesi",
        font_size: "Yazı Tipi Boyutu",
        footer: "Altbilgi",
        for: "İçin",
        forgot_password: "Parolanızı mı unuttunuz",
        form: "Biçim",
        free: "Ücretsiz",
        free_requests_included: "Ücretsiz istekler dahil",
        from: "itibaren",
        full_name: "Ad Soyad",
        generate: "Oluştur",
        generate_meta: "Meta Oluştur",
        generate_qr_code: "QR Kodu Oluştur",
        generate_reply: "Cevap Oluştur",
        generate_review: "Değerlendirme Oluştur",
        generating: "Oluşturuluyor",
        get_started: "Başlayın",
        get_started_checklist: "Başlarken Kontrol Listesi",
        get_the_lifetime_deal: "Ömür Boyu Fırsatı Yakalayın",
        getting_started: "Başlarken",
        google_fonts: "Google Yazı Tipleri",
        grouped_by_request: "İsteğe Göre Gruplandırılmış",
        has_links: "Bağlantılar Var",
        has_notes: "Notlar İçeriyor",
        has_redirects: "Yönlendirmeler Var",
        have_an_account: "Hesabınız var mı?",
        header: "Başlık",
        hidden: "Gizlenmiş",
        hidden_from_search_engines: "Arama Motorlarından Gizli",
        hidden_reviews: "Gizli Değerlendirmeler",
        hide: "Saklamak",
        hide_all_reviews: "Tüm yorumları gizle",
        hide_avatar: "Avatarı Gizle",
        hide_date: "Tarihi Gizle",
        hide_drop_shadow: "Düşen Gölgeyi Gizle",
        hide_field_label: "Alan Etiketini Gizle",
        hide_from_public: "Halktan Gizle",
        hide_name: "İsmi Gizle",
        hide_pagination: "Sayfalamayı Gizle",
        highlight_color: "Vurgu rengi",
        hipaa: "HIPAA",
        host: "Host",
        hours: "Saat",
        icon: "Simge",
        icon_size: "Simge Boyutu",
        icons: "Simgeler",
        id: "ID",
        image: "Resim",
        import: "İçe aktarmak",
        import_address1: "Müşterinin adres satırı 1.",
        import_address2: "Müşterinin adres satırı 2.",
        import_city: "Müşterinin şehri veya mahallesi.",
        import_company: "Müşterinin şirket adı.",
        import_created_at: "Değerlendirmenin tarihi.",
        import_customers: "Müşterileri içe aktar",
        import_email: "Müşterinin e-posta adresi.",
        import_first_name: "Müşterinin adı.",
        import_from_boost_space: "Boost.space içe aktar",
        import_from_hubspot: "HubSpot içe aktar",
        import_from_make_com: "Make.com içe aktar",
        import_from_pabbly: "Pabbly'den içe aktar",
        import_from_stripe: "Stripe içe aktar",
        import_from_zapier: "Zapier içe aktar",
        import_last_name: "Müşterinin soyadı.",
        import_list: "Virgülle ayrılmış liste",
        import_notes: "Bu notlar yalnızca şirket içi kullanım içindir.",
        import_phone: "Müşterinin telefon numarası.",
        import_postal_code: "Müşterinin posta kodu.",
        import_recent_reviews: "Son Değerlendirmeler İçe Aktar",
        import_review: "Değerlendirme metni.",
        import_reviews: "Değerlendirmeleri içe aktar",
        import_score: "Puanlama 1 - 5 arası.",
        import_signed_up_at: "Müşterinin başlangıç tarihi.",
        import_slug: "Bir slug veya UUID",
        import_state: "Müşterinin eyaleti veya bölgesi.",
        incentive: "Teşvik",
        include: "Katmak",
        include_sample_reviews: "Örnek değerlendirmeler ekleyin",
        incoming_webhook_url: "Gelen Webhook URL",
        inherit: "Miras almak",
        initializing: "Başlatılıyor",
        initials: "Baş harfler",
        install_in: "Yükle",
        insert_variable: "Değişken Ekle",
        instructions: "Talimatlar",
        integration: "Entegrasyon",
        integrations: "Entegrasyonlar",
        interval: "Aralık",
        introduction: "Giriş",
        invite: "Davet etmek",
        invite_client: "Client Davet Et",
        invite_failed: "Davet başarısız oldu",
        invite_member: "Üyeyi Davet Et",
        invite_sent_to: "Davet Gönderildi",
        invite_team_member: "Takım Üyesini Davet Et",
        invited: "Davetli",
        issuer_url: "Issuer URL",
        italic: "İtalik",
        joined: "Katıldı",
        key: "Anahtar",
        keywords: "Anahtar kelimeler",
        keywords_in_replies: "Cevaplardaki Anahtar Sözcükler",
        keywords_in_reviews: "Değerlendirmeler Anahtar Kelimeler",
        kiosk_page: "Kiosk Sayfası",
        label: "Etiket",
        label_font_size: "Etiket Yazı Tipi Boyutu",
        labels: "Etiketler",
        language: "Dil",
        languages: "Diller",
        large: "Büyük",
        last_charged: "Son tahsilat",
        last_name: "Soy isim",
        layout: "Düzen",
        leave: "Ayrılmak",
        leave_project: "Projeyi Bırak",
        leave_space: "Çalışma alanı bırakın",
        left: "Sol",
        let_clients_sign_in_with_sso: "Müşterilerin SSO ile oturum açmasına izin ver",
        less: "az",
        lifecycle_stage: "Yaşam Döngüsü Aşaması",
        lifetime_deal: "Ömür boyu anlaşma",
        light: "Işık",
        limit: "Sınır",
        limits: "Sınırlar",
        link: "Bağlantı",
        link_color: "Bağlantı rengi",
        link_reveal_position: "Bağlantı Pozisyonunu Bağlantı",
        link_revealer_button: "Bağlantı Göster Düğme",
        link_revealer_label: "Bağlantı Çıkarıcı Etiket",
        link_revealer_rating: "Bağlantı Açıklayıcı Puanı",
        links: "Bağlantılar",
        links_per_review_page: "Değerlendirme sayfası Başına Bağlantılar",
        list: "Liste",
        list_unsubscribe_headers: "List-Unsubscribe Başlıkları",
        load_more: "Daha Fazla Yükle",
        loading: "Yükleniyor",
        location: "Konum",
        location_address: "Konum Adresi",
        location_name: "Konum Adı",
        location_picker: "Konum Seçici",
        locations: "Konumlar",
        locations_limit: "Konum Sınırı",
        log_in: "Giriş yapmak",
        log_out: "Çıkış Yap",
        logo: "Logo",
        logo_height: "Logo Yüksekliği",
        long: "Uzun",
        lowest_rating: "En Düşük Puan",
        ltd: "LTD",
        make_default: "Varsayılan Yap",
        manage: "Üstesinden gelmek",
        manage_limits: "Sınırları Yönet",
        manage_overrides: "Geçersiz Kılmaları Yönet",
        manage_payout_account: "Ödeme Hesabını Yönet",
        manage_subscription: "Aboneliği Yönet",
        manual_entry: "Manuel Giriş",
        max: "Maksimum",
        max_size: "Maksimum Boyut",
        maximum_characters: "Maksimum Karakterler",
        maximum_customers: "Maksimum Müşteri",
        maximum_locations: "Maksimum Konumlar",
        maximum_members: "Maksimum Üye Sayısı",
        maximum_review_length: "Maksimum Değerlendirme Uzunluğu",
        maximum_tags: "Maksimum Etiketler",
        maximum_widgets: "Maksimum Widget Sayısı",
        mcp: "MCP Sunucu",
        mcp_server: "MCP Sunucu",
        mcp_server_url: "MCP Sunucu URL",
        medium: "Orta",
        member: "Üye",
        members: "Üyeler",
        menu: "Menü",
        message: "Mesaj",
        message_link_expiration: "Mesaj Bağlantı Son Kullanma Tarihi",
        messaged: "Mesajlaştık",
        messages: "Mesajlar",
        messages_clicked: "Tıklanan Mesajlar",
        messages_sent: "Gönderilen Mesajlar",
        messaging_service_sid: "Mesajlaşma Hizmeti SID",
        min: "Min",
        min_size: "Minimum Boyut",
        minimal_delay: "Minimum Gecikme",
        minimum_characters: "Minimum Karakterler",
        minutes: "Dakikalar",
        month: "ay",
        monthly: "Aylık",
        monthly_email_requests: "Aylık E-posta İstekleri",
        monthly_limit: "Aylık Limit",
        monthly_pricing_only: "Yalnızca Aylık Fiyatlandırma",
        monthly_request_limit: "Aylık İstek Limiti",
        monthly_requests: "Aylık İstekler",
        monthly_sms_requests: "Aylık SMS İstekleri",
        months: "Aylar",
        months_free: "{count} Ay Ücretsiz",
        more: "Daha",
        more_clients: "daha fazla müşteri",
        more_customers: "daha fazla müşteri",
        more_options: "Daha Fazla Seçenek",
        more_patients: "daha fazla hasta",
        more_reviews: "daha fazla değerlendirmeler",
        more_reviews_needed: "Özetlemek için daha fazla değerlendirmeye ihtiyaç var",
        more_users: "daha fazla kullanıcı",
        more_visitors: "daha fazla ziyaretçi",
        most_negative: "En olumsuz",
        most_positive: "En olumlu",
        move: "Taşınmak",
        moved: "Etkilenmiş",
        name: "İsim",
        native_reviews: "Yerel Değerlendirmeler",
        negative_term: "Olumsuz Terim",
        negative_trends: "Olumsuz Eğilimler",
        new: "Yeni",
        new_password: "Yeni Şifre",
        no: "Hayir",
        no_available_options: "Mevcut seçenek yok",
        no_credit_card_required: "Kredi kartı gerekmez",
        no_data_available: "Veri Yok",
        no_negative_trends: "Henüz olumsuz bir eğilim yok",
        no_positive_trends: "Henüz olumlu bir eğilim yok",
        no_reminders: "Hatırlatma göndermeyin.",
        no_retries: "Tekrar deneme yok",
        no_review: "Değerlendirme yok",
        none: "Hiçbiri",
        not_connected: "Bağlantılı değil",
        not_reviewed: "Değerlendirilmedi",
        notes: "Notlar",
        notifications: "Bildirimler",
        now: "Şimdi",
        number_of_charges: "Ücret Sayısı",
        number_of_reminders: "Hatırlatma Sayısı",
        number_of_retries: "Yeniden Deneme Sayısı",
        number_of_review_suggestions: "Değerlendirme Önerilerinin Sayısı",
        of: "ile ilgili",
        off: "Kapalı",
        on: "Açık",
        on_channel: "{channel} kanalında.",
        opened: "Açıldı",
        options: "Seçenekler",
        or_log_in_with_email: "veya e-posta adresinizle giriş yapın",
        or_sign_up_with_email: "veya e-posta adresinizi kullanın",
        our_reviews: "Değerlendirmeler",
        output: "Çıktı",
        page_footer: "Sayfa Alt Bilgisi",
        paid: "Ödendi",
        paragraph: "Paragraf",
        password: "Şifre",
        past_month: "Geçtiğimiz Ay",
        past_months: "Geçtiğimiz {inc} Aylar",
        past_week: "Geçtiğimiz Hafta",
        past_year: "Geçtiğimiz Yıl",
        past_years: "Geçtiğimiz {inc} Yıl",
        paused: "Duraklatıldı",
        payment_method: "Ödeme yöntemi",
        payout_status_completed: "Tamamlanmış",
        payout_status_pending: "Askıda olması",
        pending: "Askıda olması",
        pending_deployment: "Bekleyen Dağıtım",
        pending_validation: "Bekleyen Doğrulama",
        per_day: "günde",
        per_month: "ayda",
        permissions: "İzinler",
        phone: "Telefon",
        phone_number: "Telefon Numarası",
        pixels: "pikseller",
        placeholder: "Yer tutucu",
        placement: "Atama",
        plan: "Plan",
        plan_bullet1: "E-postalar, sayfalar ve widget'lardaki markamızı kaldırın",
        plan_bullet2: "Alan adınızı müşteriye yönelik sayfalar ve e-posta gönderimi için kullanın",
        plan_bullet3: "Ajanslar için beyaz etiketleme ile ürünü kendinize ait kılın",
        please_rate_our_service: "Lütfen hizmetimizi değerlendirin.",
        png: "PNG",
        policies: "Politikalar",
        popular: "Popüler",
        port: "Port",
        position: "Konum",
        positive_only: "Sadece Olumlu Değerlendirmeler",
        positive_term: "Olumlu Terim",
        positive_trends: "Olumlu Eğilimler",
        powered_by: "Tarafından desteklenmektedir",
        preview: "Önizleme",
        preview_kiosk_page: "Kiosk Sayfasının Önizlemesi",
        preview_review_page: "Önizleme Değerlendirme sayfası",
        price: "Fiyat",
        pricing: "Fiyatlandırma",
        primary_color: "Birincil Renk",
        priority: "Öncelik",
        privacy_policy: "Gizlilik Politikası",
        proceed_to_dashboard: "Gösterge Tablosuna Devam Et",
        product: "Ürün",
        profile: "Profil",
        project: "Proje",
        project_name: "Proje Adı",
        setup_ask_delay: "Bir değerlendirme istemeden önce ne kadar beklemeliyim?",
        setup_reminders: "Kaç hatırlatma gönderilmeli?",
        project_paused: "Bu proje durduruldu.",
        project_suspended: "Bu proje askıya alınmıştır.",
        project_website: "Proje Web Sitesi",
        projects: "Projeler",
        projects_limit: "Projeler Sınırı",
        publish: "Yayımla",
        publish_changes: "Değişiklikleri diğer tüm değerlendirme sayfalarında yayınla",
        published: "Yayımlandı",
        purchase: "Satın almak",
        qr_code: "QR Kodu",
        qr_code_name_placeholder: "Masa 1, Resepsiyon",
        qr_codes: "QR Kodları",
        quantity: "Miktar",
        query: "Sorgu",
        quick_import: "Hızlı içe aktarma",
        rating: "Puan",
        rating_order: "Derecelendirme Sırası",
        rating_out_of: "derecelendirme",
        rating_save_all: "Her değerlendirmeden önce derecelendirmeyi Kaydet",
        rating_save_customer: "Müşteri yorumundan önce puanı Kaydet",
        rating_save_never: "Değerlendirmeden önce derecelendirmeyi asla kaydet",
        rating_selection: "Derecelendirme Seçimi",
        rating_selector: "Derecelendirme Seçici",
        ratings: "Derecelendirmeler",
        read: "Okumak",
        reapply_highlights_eligible: "Tüm olumlu değerlendirmeler için öne çıkan noktaları yapay zeka ile yeniden oluşturun.",
        reconnect: "Yeniden bağlan",
        redeem: "Kullan",
        redirect_uri: "Yönlendirme URI'si",
        redirects: "Yönlendirmeler",
        refer_and_earn: "Tavsiye Et ve Kazan",
        referral_billing_status_active: "Abone olundu",
        referral_billing_status_canceled: "İptal edildi",
        referral_billing_status_trial: "Deneme",
        referral_billing_status_trial_expired: "Deneme Süresi Sona Erdi",
        referral_billing_status_trial_expiring: "Deneme Süresi Sona Eriyor",
        referral_program: "Referans Programı Şartları",
        referral_program_terms: "Referans Programı Şartları",
        referrals: "Yönlendirmeler",
        refresh: "Yenile",
        regenerate: "Yeniden oluşturmak",
        reject_all: "Tümünü Reddet",
        related_reviews: "Benzer Değerlendirmeler",
        related_similarity: "Benzerlik",
        remaining: "Geriye kalan",
        reminder: "Hatırlatma",
        reminders: "Hatırlatmalar",
        remove: "Kaldırmak",
        remove_client: "Client Kaldır",
        remove_cname: "CNAME kaldır",
        remove_domain: "Alan adını kaldır",
        remove_from_project: "Projeden kaldır",
        remove_member: "Üyeyi Kaldır",
        remove_smtp_configuration: "SMTP Yapılandırmasını Kaldır",
        remove_team_member: "Takım Üyesini Kaldır",
        rename: "Yeniden isimlendirmek",
        rename_template: "Şablonu Yeniden Adlandır",
        renews: "Yeniler",
        replied: "Cevaplandı",
        reply: "Cevap vermek",
        reply_to: "Yanıt adresi",
        replying_on: "Cevaplamak için",
        request: "İstek",
        request_1_review: "1 değerlendirme iste",
        request_date: "Talep Tarihi",
        request_n_reviews: "{count} değerlendirme iste",
        request_review: "Değerlendirme talebinde bulunun",
        request_reviews: "Değerlendirme talep et",
        requested: "Talep edildi",
        requested_review: "Talep Edilen Değerlendirme",
        requests: "İstekler",
        requests_left_this_month: "bu ay bırakılan istekler",
        requests_remaining: "Kalan İstekler",
        require_field: "Alan Gereksinimi",
        require_sso: "SSO gereklidir",
        required: "Gerekli",
        reschedule_message: "Mesajı Yeniden Planla",
        resend_invite: "Daveti Yeniden Gönder",
        reset_password: "Şifreyi Sıfırla",
        restore: "Eski haline getirmek",
        restore_to_defaults: "Varsayılanlara Geri Yükle",
        restore_widget: "Widget'ı Geri Yükle",
        resubscribe: "Tekrar abone ol",
        resubscribe_customer: "Müşteriyi Yeniden Abone Et",
        resync: "Yeniden Senkronize Et",
        resync_account: "Hesabı Yeniden Senkronize Et",
        resync_now: "Şimdi Yeniden Senkronize Et",
        retries: "Yeniden denemeler",
        reveal_above_form: "Yukarıdaki Formu Göster",
        reveal_after_submission: "Gönderimden Sonra Açıkla",
        reveal_below_form: "Aşağıdaki Formu Göster",
        review: "Değerlendirme",
        review_length: "Değerlendirme Uzunluğu",
        review_link: "Değerlendirme Bağlantı",
        review_missed: "Değerlendirme Kaçırıldı",
        review_not_requested: "Değerlendirme İstenmiyor",
        review_origin: "Bu değerlendirme şablondan kaynaklanmıştır",
        review_page: "Değerlendirme sayfası",
        review_pages: "Değerlendirme sayfaları",
        review_requested: "Değerlendirme İstendi",
        review_spotlight: "Öne çıkan değerlendirme",
        review_suggestion: "Değerlendirme",
        review_suggestions: "Önerileri Değerlendirme",
        review_text: "Metni Değerlendirme",
        review_wall: "Değerlendirme duvarı",
        reviewed: "Değerlendirildi",
        reviews: "Değerlendirmeler",
        reviews_ask: "Sormak",
        reviews_query_failed: "Bir sorun oluştu. Lütfen tekrar deneyin.",
        reviews_query_placeholder: "Değerlendirmelerde arayın veya bir soru sorun...",
        reviews_with_highlights: "Öne Çıkan Değerlendirmeler",
        reviews_with_replies: "Cevaplı Değerlendirmeler",
        reviews_without_replies: "Cevapsız Değerlendirmeler",
        revoke: "Geri çekmek",
        revoke_client: "Uygulamayı İptal Et",
        roadmap: "Yol haritası",
        role: "Rol",
        sans_serif: "Sans Serif",
        save: "Kaydet",
        save_preferences: "Tercihleri Kaydet",
        save_template: "Şablonu Kaydet",
        save_template_as_new: "Yeni Şablonu Kaydet",
        saved: "Kaydedildi",
        schedule: "Takvim",
        schedule_review_request: "Değerlendirme talebi planla",
        scheduled: "Planlanmış",
        score: "Puan",
        search: "Aramak",
        second: "Saniye",
        secret_key: "Gizli Anahtar",
        sections: "Bölümler",
        security_code: "Güvenlik Kodu",
        select: "Seçme",
        select_account: "Bir hesap seçin",
        select_all: "Tümünü Seç",
        select_an_option: "Bir seçenek seçin",
        select_bulk_action: "Toplu Eylemi Seç",
        select_csv_file: "CSV Dosyasını Seçin",
        select_date: "Tarih Seçin",
        select_field: "Bir alan seçin",
        select_icon: "Bir simge seçin",
        select_location: "Bir konum seçin",
        select_plan: "Bir Plan Seçin",
        select_review: "Bir Değerlendirme seçin",
        select_source: "Bir Kaynak Seçin",
        select_tag: "Bir Etiket seçin",
        selected: "Seçilmiş",
        send: "Göndermek",
        send_1_reminder: "1 Hatırlatma Gönder",
        send_2_reminders: "2 Hatırlatma Gönder",
        send_3_reminders: "3 Hatırlatma Gönder",
        send_anytime: "İstediğiniz zaman gönderebilirsiniz",
        send_between: "Arasında gönder",
        send_message: "Mesaj Gönder",
        send_retries: "{count} Tekrar Denemelerini Gönder",
        send_retry: "{count} Gönder Tekrar Dene",
        send_test: "Bir test gönderin",
        send_thanks: "Teşekkür gönder",
        sender_email_address: "Gönderen E-posta Adresi",
        sender_id: "Gönderen ID",
        sender_name: "Gönderen Adı",
        sending_domain: "Gönderim alan adı",
        sentiment: "Duygu",
        sent: "Gönderilmiş",
        sent_replies: "Gönderilen Yanıtlar",
        serif: "Serif",
        settings: "Ayarlar",
        share: "Paylaşmak",
        share_link: "Bağlantı paylaş",
        short: "Kısa",
        show: "Göstermek",
        show_1_suggestion: "Bir öneri göster",
        show_100_results: "100 Sonuç Göster",
        show_2_suggestions: "İki öneri göster",
        show_25_results: "25 Sonuç Göster",
        show_3_suggestions: "Üç öneri göster",
        show_4_suggestions: "Dört öneri göster",
        show_5_suggestions: "Beş Öneri Göster",
        show_50_results: "50 Sonuç Göster",
        show_all_reviews: "Tüm yorumları göster",
        show_arrows: "Okları Göster",
        show_avatar: "Avatarı göster",
        show_cookie_consent_banner: "Çerez onay afişini göster",
        show_date: "Gösteri Tarihi",
        show_dots: "Noktaları Göster",
        show_drop_shadow: "Gölgeyi Göster",
        show_field: "Aşağıdaki derecelendirmelerde alanı göster",
        show_full: "Tam Yıldızları Göster",
        show_photo: "Sadece Fotoğrafı Göster",
        show_positive_reviews: "Yalnızca olumlu yorumları göster",
        show_to_public: "Kamuoyuna Göster",
        showcase: "Showcase",
        showcase_page: "Showcase Sayfası",
        sign_up: "Üye olmak",
        sign_up_for_free: "Ücretsiz Kayıt Olun",
        sign_up_with_email: "E-posta ile Kayıt Ol",
        sign_in_with_sso: "SSO ile giriş yapın",
        sign_up_with_google: "Google ile Kayıt Ol",
        signature: "İmza",
        signatures: "İmzalar",
        signed_up: "Kayıtlı",
        since: "O zamandan beri",
        size: "Boyut",
        skip: "Atlamak",
        slug: "Slug",
        small: "Küçük",
        sms: "SMS",
        smtp_configuration: "SMTP Yapılandırması",
        sort: "Düzenlemek",
        source: "Kaynak",
        source_code: "Kaynak Kodu",
        sources: "Kaynaklar",
        space: "Çalışma alanı",
        space_name: "Çalışma alanı adı",
        spaces: "Çalışma alanları",
        split: "Bölmek",
        sso: "SSO",
        star_color: "Yıldız Rengi",
        stars: "Yıldızlar",
        start: "Başlangıç",
        start_free_trial: "Ücretsiz Deneme Sürümünü Başlatın",
        start_getting_more_reviews: "Daha Fazla Değerlendirmeler Almaya Başlayın",
        status: "Durum",
        store_code: "Mağaza Kodu",
        strategy: "Strateji",
        sub_processors: "Alt işlemciler",
        subject: "Konu",
        subscribe: "Abone",
        subscription: "Abonelik",
        success_page: "Başarı Sayfası",
        suggestion: "Telkin",
        suggestions: "Öneriler",
        summary: "Özet",
        support: "Destek",
        suspend: "Askıya almak",
        suspend_project: "Projeyi Askıya Al",
        suspended: "Askıya alınmış",
        svg: "SVG",
        switch_to_smtp_setup: "SMTP Kurulumuna Geçin",
        switch_to_standard_setup: "Standart Kuruluma Geç",
        symbol: "Sembol",
        sync: "Senkronizasyon",
        sync_account: "Hesap Senkronizasyonu",
        sync_now: "Şimdi Senkronize Et",
        sync_scheduled_time: "Senkronizasyon planlandı {time}",
        sync_with_facebook: "Facebook ile senkronize et",
        sync_with_google: "Google ile senkronize et",
        synced_time: "Senkronize edildi {time}",
        system: "Sistem",
        system_fonts: "Sistem Yazı Tipleri",
        tag: "Etiket",
        tag_1_customer: "Etiket 1 Müşteri",
        tag_1_review: "Etiket 1 Değerlendirme",
        tag_customers: "Müşterileri etiketle",
        tag_existing_reviews: "Mevcut Değerlendirmeler Etiket",
        tag_n_customers: "Etiket {count} Müşteriler",
        tag_n_reviews: "Etiket {count} Değerlendirmeler",
        tag_reviews: "Değerlendirmeleri etiketle",
        tag_rule: "Etiket Kuralı",
        tag_with_ai: "AI ile etiketle",
        tags: "Etiketler",
        tags_for_customers: "Müşteriler için Etiketler",
        tags_for_reviews: "Değerlendirmeler için Etiketler",
        team: "Takım",
        team_member: "Takım Üyesi",
        team_members: "Takım Üyeleri",
        template: "Şablon",
        templates: "Şablonlar",
        terms_of_service: "Hizmet Şartları",
        test_template: "Test şablonu",
        tests: "Testler",
        text: "Metin",
        text_alignment: "Metin Hizalaması",
        text_color: "Metin Rengi",
        thank_you_messages: "Teşekkür mesajları",
        thanks: "Teşekkürler",
        theme: "Tema",
        third: "Üçüncü",
        time_zone: "Zaman Dilimi",
        timeframe: "Zaman aralığı",
        title: "Başlık",
        tone: "Ton",
        top: "Tepe",
        top_left: "Sol Üst",
        top_right: "Sağ Üst",
        total_charges: "Toplam Ücretler",
        total_reviews: "Toplam Değerlendirmeler",
        trigger: "Tetiklemek",
        trigger_charged: "Ücretlendirmeden sonra istek gönder",
        trigger_created: "Kayıttan sonra istek gönder",
        try_free: "Ücretsiz deneyin",
        try_it_free: "Ücretsiz Deneyin",
        type: "Tip",
        types: "Türler",
        unarchive: "Arşivden Çıkar",
        unarchive_customer: "Müşteri Arşivinden Çıkarma",
        underline: "Altı çizili",
        unflag_as_duplicate: "Yinelenen olarak işaretlemeyi kaldır",
        unknown: "Bilinmeyen",
        unlimited: "sınırsız",
        unnamed: "İsimsiz",
        unpublish: "Yayımlamayı kaldır",
        unpublished: "Yayımlanmamış",
        unreplied: "Yanıtlanmamış",
        unsent_messages: "Gönderilmemiş Mesajlar",
        unsubscribe: "Abonelikten çık",
        unsubscribe_1_customer: "1 müşterinin aboneliğini iptal et",
        unsubscribe_customer: "Aboneliği İptal Etme Müşterisi",
        unsubscribe_customers: "Abonelikten Çıkan Müşteriler",
        unsubscribe_n_customers: "{count} müşterinin aboneliğini iptal et",
        unsubscribe_text: "Abonelikten Çıkma Metni",
        unsubscribed: "Abonelikten Çıkıldı",
        unsuspend: "Askıyı kaldır",
        unsuspend_project: "Projeyi askıya almayı kaldır",
        unverified: "Doğrulanmamış",
        update: "Güncelleme",
        update_password: "Şifreyi Güncelle",
        update_plan: "Güncelleme Planı",
        update_share_template: "Şablonu Güncelle",
        updated: "Güncellendi",
        updates: "Güncellemeler",
        upgrade: "Yükselt",
        upgrade_for_more: "Daha fazlası için yükseltin",
        upgrade_to_use: "Bu özelliği kullanmak için lütfen yükseltin",
        upload: "Yüklemek",
        upload_csv: "CSV dosyasını yükle",
        upload_icon: "Bir simge yükle",
        url: "URL",
        use: "Kullanmak",
        use_filters_for_aggregate: "Toplam için Filtreleri Kullanın",
        user: "Kullanıcı",
        user_id: "Kullanıcı ID",
        user_info: "Kullanıcı Bilgileri",
        username: "Kullanıcı adı",
        utc: "UTC",
        validate: "Doğrula",
        validate_customer_email: "Müşteri E-postasını Doğrula",
        validation: "Doğrulama",
        validations: "Doğrulamalar",
        value: "Değer",
        verify: "Doğrulamak",
        verify_email_address: "E-posta Adresini Doğrula",
        view: "Görüntüle",
        view_all: "Tümünü Görüntüle",
        view_all_features: "Tüm Özellikleri Görüntüle",
        view_available_fields: "Mevcut Alanları Görüntüle",
        view_documentation: "Dokümantasyonu Görüntüle",
        view_email_templates: "E-posta Şablonlarını Görüntüle",
        view_review_pages: "Değerlendirme sayfaları Görüntüle",
        view_reviews: "Değerlendirmeler Görüntüle",
        view_settings: "Görünüm Ayarları",
        view_setup_guide: "Kurulum Kılavuzunu Görüntüle",
        view_showcase: "Showcasei Görüntüle",
        view_strategy: "Stratejiyi Görüntüle",
        visibility: "Görünürlük",
        visible: "Görünür",
        visible_reviews: "Görünür Değerlendirmeler",
        visible_to_search_engines: "Arama Motorları Tarafından Görünür",
        wait_between_reminders: "Hatırlatıcılar arasında bekleyin",
        wait_period: "Bekleme Süresi",
        webhook: "Web kancası",
        webhooks: "Web kancaları",
        website: "Web sitesi",
        weekly: "Haftalık",
        weeks: "Haftalar",
        widget: "Widget",
        widgets: "Widget'lar",
        with_ai: "AI ile",
        worst_to_best: "En kötüden en iyiye",
        write: "Yazmak",
        written_reviews: "Yazılı Değerlendirmeler",
        year: "yıl",
        yearly: "Yıllık",
        yes: "Evet",
        your_referral_link: "Yönlendirme Bağlantı"
    },
    landing: {
        announcement: "MCP sunucumuzla itibar raporları alın",
        counter: "5.000+ yerel hizmet işletmesine katılın",
        counter_agencies: "500+ acente tarafından yorum yönetimi için kullanılıyor",
        counter_ai: "Claude ve ChatGPT aracılığıyla itibarınızı yönetin.",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Başka bir kontrol paneline giriş yapmadan yanıtlar alın.",
            "Ekibinizin halihazırda kullandığı sohbet araçlarında itibarınızı yönetin.",
            "Araştırmak yerine sorarak her hafta saatlerce zamandan Kaydet ."
        ],
        ai_screen_1_subtitle: "İtibar yönetimi çalışmalarınız, zaten düşündüğünüz noktada size yol göstermeli. Claude veya ChatGPT yanıt gerektiren konuları, bir sonraki adımda kime sorulacağını veya haftanın nasıl geçtiğini sorun ve araç değiştirmeden canlı yanıtlar alın.",
        ai_screen_1_title: "Claude sorun veya ChatGPT danışın",
        ai_screen_2_badge: "Yapay Zeka Yanıtları",
        ai_screen_2_bullets: [
            "Genel geçer bir üslup kullanmadan daha hızlı yanıt verin.",
            "Meşgulken asla değerlendirmeler cevap vermeden bırakmayın.",
            "Herkese açık her yanıtta marka sesinizi koruyun."
        ],
        ai_screen_2_subtitle: "Yanıtlanmamış her yorum, güven kazanmak için kaçırılmış bir fırsattır. Yapay zeka, size benzeyen yanıt taslakları oluşturur, böylece dakikalar içinde yanıt kuyruğunu temizleyebilir ve yazma zahmetine girmeden müşterileriniz için hazır bulunabilirsiniz.",
        ai_screen_2_title: "Gereksiz ayrıntılara girmeden cevap verin.",
        ai_screen_3_badge: "Yapay Zeka Önerileri",
        ai_screen_3_bullets: [
            "Daha fazla müşteriyi bitiş çizgisine ulaştırın.",
            "Özgün ve paylaşılabilir geri bildirimler toplayın.",
            "Mutlu ziyaretleri, gururla sergileyebileceğiniz değerlendirmeler dönüştürün."
        ],
        ai_screen_3_subtitle: "Çoğu insan yorum bırakmak ister ama asla bırakmaz. Onlara kendi ses tonunuzda net bir dille ifade verin ki daha fazla içerik sunulsun ve yazdıklarının daha güçlü ve etkileyici olması sağlansın.",
        ai_screen_3_title: "Daha fazla 5 yıldızlı değerlendirmeler alın",
        ai_screen_4_badge: "Yapay Zeka Etiketleme",
        ai_screen_4_bullets: [
            "Sorun haline gelmeden önce kalıpları tespit edin.",
            "Reytingleri gerçekten artıran temaları bulun.",
            "Yüzlerce değerlendirmeler elle okumaktan vazgeçin."
        ],
        ai_screen_4_subtitle: "Neler olup bittiğini anlamak için her yorumu tekrar okumak zorunda kalmamalısınız. Yapay zeka, geri bildirimleri önemsediğiniz temalara göre düzenler, böylece sorunları daha çabuk çözebilir ve müşterilerin sevdiği şeylere odaklanabilirsiniz.",
        ai_screen_4_title: "Müşterilerin ne söylediğini öğrenin.",
        ai_summary_1_desc: "Kendi üslubunuza uygun Google ve Facebook yanıt taslakları oluşturun veya bir programa göre otomatik yanıt verin.",
        ai_summary_1_title: "Yapay zeka yanıtları",
        ai_summary_2_desc: "Müşteriler sayfanızda geri bildirim bıraktıklarında, kullanıma hazır inceleme önerileri sunun.",
        ai_summary_2_title: "Yapay zeka inceleme önerileri",
        ai_summary_3_desc: "Ürünlerinizdeki olumlu değerlendirmeler en iyi ifadeleri öne çıkarın, görselleri sergileyin ve paylaşın.",
        ai_summary_3_title: "Yapay zeka öne çıkanlar",
        ai_summary_4_desc: "Tanımladığınız kurallardan etiketler uygulayarak bekleme süreleri veya hizmet kalitesi gibi temaların düzenli kalmasını sağlayın.",
        ai_summary_4_title: "Yapay zeka otomatik etiketleme",
        ai_summary_5_desc: "Son değerlendirmeler özetlerini, sayımlarını, temalarını ve üzerinde harekete geçmeye değer endişeleri içeren kısa bilgilerle edinin.",
        ai_summary_5_title: "Değerlendirme özetleri",
        ai_summary_6_desc: "Her yorumu tek tek okumadan, yükselen övgüleri ve ortaya çıkan şikayetleri tespit edin.",
        ai_summary_6_title: "Olumlu ve olumsuz trendler",
        ai_summary_7_desc: "Benzer değerlendirmeler, herhangi bir geri bildirimin yanına ekleyerek kalıpları ve tekrarları kolayca görebilirsiniz.",
        ai_summary_7_title: "İlgili değerlendirmeler",
        ai_summary_8_desc: "değerlendirmeler hakkında sade bir dille sorular sorun ve açabileceğiniz kaynaklarla birlikte yanıtlar alın.",
        ai_summary_8_title: "Yapay zekaya sor",
        ai_summary_9_desc: "Sohbet ortamında itibarınızı yönetmek için Claude, ChatGPT ve diğer MCP istemcilerini bağlayın.",
        ai_summary_9_title: "Asistanlar için MCP",
        ai_summary_10_desc: "Hacim, derecelendirmeler, konumlar, yanıtlar ve erişim gibi unsurları kapsayan canlı İtibar Raporlarını alın.",
        ai_summary_10_title: "İtibar raporları",
        ai_summary_11_desc: "Yönlendirici ton, anahtar kelimeler ve özel talimatlar sayesinde her yapay zeka çıktısı markanızın tarzını yansıtır.",
        ai_summary_11_title: "Marka bilincine sahip yapay zeka",
        ai_summary_12_desc: "Yazılı yorumların yıldızların ötesinde ne kadar olumlu veya olumsuz hissettirdiğini puanlayın ve dikkat gerektirenleri sıralayın.",
        ai_summary_12_title: "Duygu",
        industries: {
            accountants: "Muhasebeciler",
            auto_repair: "Oto tamircileri",
            chiropractors: "Kayropraktörler",
            cleaning: "Temizlikçiler",
            contractors: "Müteahhitler",
            dentists: "Diş hekimleri",
            doctors: "Doktorlar",
            electricians: "Elektrikçiler",
            financial_advisors: "Finansal danışmanlar",
            hvac: "İklimlendirme teknisyenleri",
            insurance_brokers: "Sigorta brokerleri",
            landscapers: "Peyzajcılar",
            law_firms: "Avukatlar",
            locksmiths: "Çilingirler",
            mortgage_brokers: "Mortgage brokerları",
            optometrists: "Optometristler",
            personal_trainers: "Kişisel antrenörler",
            pest_control: "Haşere ilaçlayıcılar",
            physical_therapists: "Fizyoterapistler",
            plumbers: "Tesisatçılar",
            real_estate: "Emlakçılar",
            restaurants: "Restoran sahipleri",
            salons: "Kuaförler",
            self_storage: "Depo işletmecileri",
            spas: "Güzellik uzmanları",
            tour_guides: "Tur rehberleri",
            veterinarians: "Veterinerler"
        },
        industries_title: "Yerel hizmet işletmeleri için yorum yönetimi",
        stat_1_article: "Tüketici Araştırma Raporu",
        stat_1_desc: "İnsanlar bir işletmeye çevrimiçi olarak güvenmeden önce 100'den fazla değerlendirmeler istiyorlar.",
        stat_1_source: "Salsify",
        stat_1_title: "Değerlendirmeler Güven Kazandırır",
        stat_2_article: "Yerel Tüketici Değerlendirme Anketi",
        stat_2_desc: "Yerel işletmeleri karşılaştıran alışverişçiler, her yoruma yanıt verenleri tercih ediyor.",
        stat_2_source: "BrightLocal",
        stat_2_title: "Kimin yanıt vereceğini seçin",
        stat_3_article: "Değerlendirmeler, İtibar ve Gelir",
        stat_3_desc: "Puanınızdaki küçük bir artış, kazancınızda gerçek bir yükseliş anlamına gelebilir.",
        stat_3_source: "Harvard İşletme Okulu",
        stat_3_title: "Yıldız Başına Gelir",
        stat_4_article: "Tüketicilerin Yapay Zeka Arama Sonuçlarına Bağımlılığı",
        stat_4_desc: "İnsanlar yapay zekaya kimi seçeceğini sorduğunda, sizin değerlendirmeler cevabın yazılmasına yardımcı oluyor.",
        stat_4_source: "Bain & Şirketi",
        stat_4_title: "Yapay Zeka Aramasına Güvenin",
        subtitle: "Değerlendirmeleri otomatik pilotta talep edin. Daha fazla 5 yıldızlı derecelendirme alın. Rakiplerinizden daha üst sıralarda yer alın.",
        agencies_screen_1_badge: "Portal",
        agencies_screen_1_bullets: [
            "Her abonelik sözleşmesiyle birlikte markalı bir portal satışı yapın.",
            "Müşterilerinizi üçüncü taraf bir giriş sistemine değil, kendi ekosisteminize dahil edin.",
            "Yazılım şirketi gibi görünün, ama bir tane kurmadan."
        ],
        agencies_screen_1_subtitle: "Her müşteriye sizin yaptığınız bir ürün gibi görünen bir portal verin: logonuz, renkleriniz, alan adınız. Ardından yorum yönetimini her ay giriş yaptıkları yinelenen bir hizmet olarak paketleyin. Bir araç önermiyorsunuz. Bir tane teslim ediyorsunuz.",
        agencies_screen_1_title: "Sizin yaptığınızı sandıkları bir portal",
        agencies_screen_2_badge: "Kontrol",
        agencies_screen_2_bullets: [
            "Başlangıç, gelişim ve premium paketlerle uyumlu özellikler",
            "Doğru kişileri davet edin ve her müşterinin ne gördüğünü kontrol edin.",
            "Proje bazında istekleri, konumları ve limitleri geçersiz kılın."
        ],
        agencies_screen_2_subtitle: "Her müşteri her şeyi almamalı. Ekipleri belirli projelere davet edin, roller belirleyin ve paketlerinizin faturalandırmanıza uyması için hesap başına özellikleri ve limitleri geçersiz kılın. Müşteriler büyüdükçe erişimi upsell edin — her paket için özel geliştirme olmadan.",
        agencies_screen_2_title: "Müşteri bazında erişimi kontrol edin",
        agencies_screen_3_badge: "Yapay zeka",
        agencies_screen_3_bullets: [
            "Müşterilere her hafta saatlerce zaman kaydet yapay zeka destekli yanıtlar sunun.",
            "Her projenin MCP aracılığıyla Claude veya diğer asistanlarla bağlantı kurun.",
            "Yapay zekayı müşteriler için premium bir eklenti olarak ürünleştirin."
        ],
        agencies_screen_3_subtitle: "Sadece yorum yönetmeyin. Müşterilere yanıt taslağı yazan, geri bildirimi etiketleyen ve proje MCP sunucusu üzerinden Claude veya diğer asistanlarla çalışan yapay zeka verin. Acentelerin paketleyip upsell edip yenileyebileceği modern bir yetenek — her hesap için içerik ekibi olmadan.",
        agencies_screen_3_title: "Müşterilerin ödeyeceği yapay zeka",
        agencies_screen_4_badge: "Ölçek",
        agencies_screen_4_bullets: [
            "Tek bir hesap üzerinden birçok işletmeye ait değerlendirmeler yönetin.",
            "Toplu fiyatlandırma ile kazandığınız lokasyonları ekleyin.",
            "Her yeni müşteriyi düzenli gelir kaynağına dönüştürün."
        ],
        agencies_screen_4_subtitle: "Bir acente koltuğu. Düzinelerce işletme. Her müşteri konumunda toplama, yanıt ve raporlamayı tek bir hub’dan yürütün; hesap ekledikçe marjı büyütün. Acenteler itibarı tek seferlik proje değil, ölçeklenebilir gelir akışına böyle çevirir.",
        agencies_screen_4_title: "Her müşteride ölçeklenin",
        agencies_summary_10_desc: "Projeleri, müşterileri ve ekibi yönetmek için Claude veya diğer yardımcılarla iletişime geçin.",
        agencies_summary_10_title: "MCP Ajansı",
        agencies_summary_11_desc: "Her müşteriye eksiksiz inceleme araç seti sunulur: veri toplama, yapay zeka, araçlar ve daha fazlası.",
        agencies_summary_11_title: "İş Dünyasında Her Şey",
        agencies_summary_12_desc: "Ajans iş akışlarını ve müşteri uygulamalarını anlayan bir ekipten yardım alın.",
        agencies_summary_12_title: "Özel destek",
        agencies_summary_1_desc: "İşletmeler, sizin geliştirdiğiniz bir ürüne benzeyen bir portal üzerinden itibar yönetimini gerçekleştirirler.",
        agencies_summary_1_title: "Markalı müşteri portalı",
        agencies_summary_2_desc: "Portalı kendi alan adınız üzerinden çalıştırın, böylece her giriş sizin markanızla ilgili kalır.",
        agencies_summary_2_title: "Gümrük acentesi alanı",
        agencies_summary_3_desc: "Müşterilerinizin kimlik doğrulama sağlayıcınızla tek tıklamayla oturum açmasına izin verin.",
        agencies_summary_3_title: "Tek oturum açma",
        agencies_summary_4_desc: "Müşterileri belirli projelere davet edin ve neleri görebileceklerini kontrol edin.",
        agencies_summary_4_title: "İşletme davetleri ve rolleri",
        agencies_summary_5_desc: "Paketlerinize uygun olarak proje başına kapasite taleplerini, konumları ve özellikleri belirleyebilirsiniz.",
        agencies_summary_5_title: "Proje başına geçersiz kılmalar",
        agencies_summary_6_desc: "Şirket içi ekibinize tüm müşteri projelerine tam erişim izni verin.",
        agencies_summary_6_title: "Ajans ekibi koltukları",
        agencies_summary_7_desc: "Önce 5 lokasyonla başlayın, büyüdükçe toplu fiyatlandırma ile daha fazla lokasyon ekleyin.",
        agencies_summary_7_title: "Çoklu lokasyon ölçeği",
        agencies_summary_8_desc: "Sistem bildirimleri, ajansınızın alan adından ve müşteriler kendi alan adlarını eklememişse proje bazında gönderilir.",
        agencies_summary_8_title: "Beyaz etiketli gönderim",
        agencies_summary_9_desc: "Ajans API ile projeleri, müşterileri ve ekibi otomatikleştirin.",
        agencies_summary_9_title: "Ajans API",
        demo_footer: "Size uygun bir zaman seçin. Her şeyi birlikte gezecek ve sorularınızı yanıtlayacağız.",
        desc_contact: "Bir sorunuz mu var veya bir konuda yardıma mı ihtiyacınız var? Aşağıdan bir mesaj gönderin, gerisini biz hallederiz.",
        mcp_aria: "MCP aracılığıyla More Good Reviews bağlı yapay zeka asistanı demosu",
        mcp_prompts_aria: "Örnek istemler",
        review_flow_aria: "E-posta yoluyla yapılan yorum isteklerini, yorum sayfasını, Google değerlendirmeler ve özel geri bildirimleri gösteren kart slayt gösterisi.",
        review_flow_autopilot: "Otomatik pilot modunda çalışıyor.",
        review_flow_card_email_desc: "Bir müşteriyle işiniz bittiğinde, otomatik olarak markanıza özel bir talep e-postası gönderiyoruz; bu e-postada tek dokunuşla inceleme sayfanıza yönlendiren bir bağlantı bulunuyor.",
        review_flow_card_email_title: "İsteği gönderin",
        review_flow_card_feedback_desc: "Düşük puanlar öncelikle özel geri bildirimleri açar, böylece durumu düzeltebilirsiniz. Müşteriler yine de herkese açık bir yorum bırakmayı seçebilirler.",
        review_flow_card_feedback_title: "Zorlu geri bildirimler alın.",
        review_flow_card_google_desc: "Memnun müşteriler, herkese açık bir Google yorumu bırakmak için net bir yola sahip oluyor, böylece övgüler yeni müşterilerin aradığı yerlerde görünüyor.",
        review_flow_card_google_title: "Google övgüler gönderin",
        review_flow_card_review_desc: "Ziyaretçiler değerlendirme sayfanıza gelir, bir puan seçer ve sonraki adım, değerlendirmelerin nasıl gittiğine bağlıdır.",
        review_flow_card_review_title: "Müşteri bir puanlama seçiyor.",
        review_flow_next: "Sonraki adım",
        review_flow_prev: "Önceki adım",
        review_flow_step_email: "Değerlendirme İstek",
        review_flow_step_feedback: "veya Geri Bildirim İsteyin",
        review_flow_step_google: "Herhangi bir Değerlendirme sitesine giden yol",
        review_flow_step_review: "Puan isteyin",
        review_flow_steps_aria: "Değerlendirme talebi adımları",
        summary_10_desc: "Müşterilerinizi ve değerlendirmeler düzenleyerek filtreleme yapabilir ve hızlıca harekete geçebilirsiniz.",
        summary_10_title: "Müşteri ve yorum etiketleme",
        summary_11_desc: "Zapier, More Good Reviews zaten kullandığınız araçlara entegre eder.",
        summary_11_title: "Herhangi bir uygulamaya bağlanın",
        summary_12_desc: "Claude, ChatGPT ve diğer MCP istemcilerinden gelen itibarınızı yönetin.",
        summary_12_title: "Yapay zekâ asistanları için MCP",
        summary_1_desc: "Planlı e-posta ve SMS iletişimi, hatırlatıcılarla birlikte, otomatik olarak çalışır.",
        summary_1_title: "Otomatik inceleme talepleri",
        summary_2_desc: "Markanıza, ses tonunuza ve teklifinize uygun e-posta ve SMS .",
        summary_2_title: "Markalı şablonlar",
        summary_3_desc: "Kişilerden özel geri bildirim toplayın veya onları Google, Facebook ve daha fazlasına yönlendirin.",
        summary_3_title: "Değerlendirme sayfaları",
        summary_4_desc: "Yazdırılabilir kodlar ve mağazada tam ekran teslimat.",
        summary_4_title: "QR kodları ve kiosk",
        summary_5_desc: "Web sitenizin herhangi bir yerine değerlendirme ve değerlendirmeler ekleyin.",
        summary_5_title: "Web sitesi widget'ları",
        summary_6_desc: "En iyi değerlendirmeler için herkese açık, marka kimliğinizi yansıtabileceğiniz bir sayfa.",
        summary_6_title: "Showcase sayfası",
        summary_7_desc: "değerlendirmeler İçe aktar ve tek bir yerden yanıtlayın.",
        summary_7_title: "Google ve Facebook senkronizasyonu",
        summary_8_desc: "Müşterilerin yorum bırakmasına yardımcı olan sayfa içi öneriler.",
        summary_8_title: "Yapay zeka incelemesi yazma yardımı",
        summary_9_desc: "değerlendirmeler için taslak yanıtlar, özetler, trendler ve Yapay Zekaya Soru Sor özelliği.",
        summary_9_title: "Yapay zeka yanıtları ve içgörüleri",
        subtitle_agencies_feature_summary: "White label portal, müşteri erişimi, ölçek ve otomasyon — markanız altında.",
        subtitle_ai_feature_summary: "Yanıtlar, etiketleme, analizler ve yardımcı araçlar, itibar yönetimi iş akışınıza entegre edilmiştir.",
        subtitle_feature_summary: "Toplama, görüntüleme, yapay zeka ve entegrasyonlar — siz hazır olduğunuzda hazır.",
        subtitle_mcp: "Claude, ChatGPT ve diğer MCP istemcilerini bağlayın; yorumlar, konumlar ve outreach hakkında doğal dille sorun.",
        subtitle_review_flow: "Otomatik olarak yorum isteyin. Müşteriler istediği zaman genel bir yorum bırakabilir. Özel geri bildirim isteğe bağlıdır.",
        title: "Yapay zeka itibar yönetimi ile",
        title_agencies: "Yorumları şuna dönüştürün:",
        title_agencies_feature_summary: "Acentelerin ihtiyaç duyduğu her şey",
        title_agencies_phrases: {
            branded_product: "size ait markalı bir ürün",
            recurring_retainers: "aylık tekrarlayan retainer’lar",
            revenue_stream: "yeni bir gelir kaynağı"
        },
        title_ai: "Yapay zekânıza sorun.",
        title_ai_feature_summary: "Yapay zekanın sizin için yapabileceği her şey",
        title_ai_phrases: {
            weekly_report: "haftalık itibar raporu için",
            send_from_chat: "değerlendirme taleplerini göndermek",
            next_steps: "atılacak sonraki adımlar için"
        },
        title_contact: "Nasıl yardımcı olabiliriz?",
        title_faq: "Sık Sorulan Sorular",
        title_feature_summary: "Kutudaki her şey",
        title_footer: "Yorum peşinde koşmayı bırakın. Almaya başlayın.",
        title_footer_ai: "itibarınız hakkında",
        title_ltd: "Sınırlı süreli ömür boyu fırsatımızla bir kez ödeyin ve sonsuza kadar kullanın",
        title_mcp: "İtibariniz hakkında yapay zekaya sorun",
        title_review_flow: "Harika deneyimleri yorumlara dönüştürün",
        title_phrases: {
            autopilot: "otomatik yorum istemek için",
            google_reviews: "daha fazla Google yorumu almak için",
            suggested_by_chatgpt: "ChatGPT tarafından önerilmek"
        },
        title_pricing: "Her özellik. Basit fiyatlandırma.",
        title_reviews: "İnceleme yönetiminde neden #1 olarak değerlendirildiğimizi görün"
    },
    plans: {
        agency: {
            agency_api: "Ajans API",
            branded_portal: "Markalı müşteri portalı",
            client_invites: "İşletme davetleri, roller ve geçersiz kılmalar",
            custom_domain: "Gümrük acentesi alanı",
            everything_in_business: "İş planındaki her şey",
            locations_included: "5 lokasyon dahil",
            review_requests: "Ayda konum başına 5.000 değerlendirme talebi",
            sso: "Tek oturum açma (SSO)",
            support: "Özel müşteri desteği",
            volume_pricing: "Toplu alımlarda aylık 49$'dan başlayan fiyatlarla."
        },
        business: {
            ai: "Yapay Zeka Yanıtları, İçgörüler ve Yapay Zekaya Sor",
            api_mcp: "API ve MCP Sunucu",
            custom_domains: "Özel e-posta ve yorum sayfası alan adları",
            google_facebook: "Google İşletme Profili ve Facebook",
            locations_included: "1 konum dahil",
            review_requests: "{count} inceleme talepleri \/ konum \/ ay",
            support: "Özel müşteri desteği",
            unlimited_customers: "Sınırsız müşteri",
            volume_pricing: "Toplu alımlarda aylık 99$'dan başlayan fiyatlarla."
        },
        descriptions: {
            agency: "Markaları altında müşteri itibarını yöneten ajanslar için. Büyümenize paralel olarak toptan fiyatlarla beş lokasyon, ayrıca markalı bir portal ve müşteri erişimi dahildir.",
            business: "Kendi itibar yönetimini üstlenen şirketler için. Lokasyon başına ödeme yapın, toplu alımlarda indirimlerden yararlanın ve yapay zeka, entegrasyonlar ve sınırsız müşteri erişiminden faydalanın."
        },
        selectors: {
            agency_included: "{count} Dahil Edilen Konumlar",
            agency_tier: "+{from}–{to} konumları · {price}\/{month} her biri",
            agency_tier_plus: "+{from}+ konumlar · {price}\/{month} her biri",
            business_tier: "{from}–{to} konumları · {price}\/{month} her biri",
            business_tier_plus: "{from}+ konumlar · {price}\/{month} her biri"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Bir müşteri ekleyin ve yorum isteyin.",
            customers_to_ask: "Müşterilerden değerlendirmeler istemek için onları bulun.",
            location_leaderboard: "Konum performansını karşılaştırın",
            outreach_health: "Taleplerin teslimat durumunu denetle",
            review_digest: "Haftalık değerlendirme özeti",
            send_review_requests: "Değerlendirme taleplerini toplu olarak gönderin"
        },
        texts: {
            add_customer_and_ask: "Size verdiğim iletişim bilgilerini kullanarak yeni bir müşteri ekleyin, ardından onlara e-posta yoluyla 2 hatırlatma içeren bir değerlendirme talebi planlayın.",
            customers_to_ask: "Daha önce yorum yapmaları istenmemiş en fazla 50 müşteriyi, kayıt tarihine göre en yenisi başta olmak üzere sıralayın. Aboneliğini iptal edenleri atlayın. İsim, e-posta ve kayıt tarihini ekleyin.",
            location_leaderboard: "Konuma göre 90 günlük bir sıralama listesi oluşturun; bu listede yorum sayısı, ortalama puan, 5 yıldızlı değerlendirme yüzdesi ve önceki 90 güne kıyasla trend yer almalıdır. Puanlara göre sıralayın ve 0,2 yıldızın üzerindeki düşüşleri işaretleyin.",
            outreach_health: "Son 14 gün içinde gönderilen e-posta mesajları için toplam gönderilen sayısı, teslimat oranı, açılma oranı, tıklama oranı ve başarısızlık oranını raporlayın. Herhangi bir anormalliği işaretleyin.",
            review_digest: "Son 7 gündeki tüm değerlendirmeler özetleyin. Yorum sayısı, ortalama puan, kaynak ve konuma göre dağılım, en çok konuşulan 3 tema ve en çok endişe duyulan 3 konuyu ekleyin.",
            send_review_requests: "Son 30 gün içinde kayıt olmuş ve henüz talep edilmemiş müşteriler için, 2 hatırlatma içeren bir e-posta ile değerlendirme talebi planlayın. Önce listeyi gösterin ve onayımı bekleyin."
        }
    },
    messages: {
        activated: "Başarıyla etkinleştirildi.",
        archived: "Başarıyla arşivlendi.",
        canceled: "Başarıyla iptal edildi.",
        cannot_copy: "Panoya kopyalanamıyor",
        cname_active: "CNAME durumu aktif.",
        cname_not_active: "CNAME durumu henüz aktif değil.",
        connected: "Başarıyla bağlandı.",
        cookie_banner_text: "Kullanıcı deneyiminizi iyileştirmek için çerezler kullanıyoruz. Tercihlerinizi özelleştirebilir veya tümünü kabul edebilirsiniz.",
        cookie_category_analytics_desc: "Web sitesi trafiğini ve ürün kullanımını ölçmek için kullanılır. Bu çerezler, ziyaretçilerin sitemizi nasıl kullandığını anlamamıza yardımcı olur.",
        cookie_category_essential_desc: "Her zaman aktif. Bu çerezler sitenin çalışması için gereklidir ve kapatılamaz.",
        cookie_category_functional_desc: "Canlı sohbet gibi gelişmiş özellikleri etkinleştirin. Bu çerezler sizi reklam amaçlı izlemez.",
        cookie_category_marketing_desc: "Reklam ve kampanya ölçümü için kullanılır. Bunlar arasında reklam pikselleri ve atıf araçları yer alabilir.",
        copied: "Başarıyla kopyalandı.",
        copied_to_all_ratings: "Tüm puanlara kopyalandı. Uygulamak için kaydedin.",
        created: "Başarıyla oluşturuldu.",
        deactivated: "Başarıyla devre dışı bırakıldı.",
        deleted: "Başarıyla silindi.",
        disconnected: "Başarıyla bağlantı kesildi.",
        duplicated: "Başarıyla kopyalandı.",
        error: "Bir sorun oluştu. Lütfen tekrar deneyin.",
        google_connect_failed: "Google bağlanamadık. Tekrar deneyebilir veya şimdilik bu adımı atlayabilirsiniz.",
        inquiry_sent: "Talebiniz için teşekkürler. En kısa sürede sizinle iletişime geçeceğiz.",
        oauth_consent_intro: "{client} hesabınıza erişim izni istiyor.",
        oauth_request_missing: "OAuth yetkilendirme isteği eksik veya süresi dolmuş.",
        operation_connection_sync_failed: "{integration_name} senkronizasyonu başarısız oldu.",
        operation_connection_sync_progress: "{integration_name} ile senkronizasyon yapılıyor…",
        operation_connection_sync_success: "{integration_name} senkronizasyonu tamamlandı.",
        operation_customer_import_failed: "Müşteri içe aktarma işlemi başarısız oldu.",
        operation_customer_import_progress: "İthalatçı müşteriler…",
        operation_customer_import_success: "Müşteri içe aktarma işlemi tamamlandı.",
        operation_review_import_failed: "Değerlendirme içe aktarma işlemi başarısız oldu.",
        operation_review_import_progress: "değerlendirmeler içe aktarılıyor…",
        operation_review_import_success: "İçe aktarma Değerlendirme tamamlandı.",
        operation_review_scrape_failed: "Son inceleme içe aktarma işlemi başarısız oldu.",
        operation_review_scrape_progress: "Son değerlendirmeler içe aktarılıyor…",
        operation_review_scrape_success: "Son inceleme içe aktarma işlemi tamamlandı.",
        processed: "Başarıyla işlendi.",
        published: "Başarıyla yayınlandı.",
        purchased: "Başarıyla satın alındı.",
        queued: "Başarıyla planlandı.",
        refreshed: "Başarıyla yenilendi.",
        removed: "Başarıyla kaldırıldı.",
        resubscribed: "Başarıyla yeniden abone olundu.",
        revoked: "Başarıyla iptal edildi.",
        saved: "Başarıyla kaydedildi.",
        scheduled: "Başarıyla planlandı.",
        sent: "Başarıyla gönderildi.",
        started: "Başarıyla başlatıldı.",
        stopped: "Başarıyla durduruldu.",
        sso_failed: "SSO ile yetkilendirme yapılamadı.",
        sso_invalid_callback: "Geçersiz SSO geri çağırma işlevi.",
        sso_not_configured: "SSO yapılandırılmamış.",
        sso_openid_config_failed: "OpenID yapılandırması yüklenemedi.",
        sso_token_exchange_failed: "SSO token değişimi tamamlanamadı.",
        subscribed: "Başarıyla abone olundu.",
        suspended: "Başarıyla askıya alındı.",
        synced: "Başarıyla senkronize edildi.",
        unarchived: "Başarıyla arşivden çıkarıldı.",
        unpublished: "Başarıyla yayından kaldırıldı.",
        unscheduled: "Başarıyla plandan çıkarıldı.",
        unsubscribed: "Abonelikten başarıyla çıkıldı.",
        unsuspended: "Başarıyla askıya alma işlemi kaldırıldı.",
        updated: "Başarıyla güncellendi.",
        upgraded: "Başarıyla yükseltildi.",
        validated: "Başarıyla doğrulandı.",
        verified: "Başarıyla doğrulandı."
    },
    notices: {
        agency: "Bir ajans mı yönetiyorsunuz? Ürünümüzü beyaz etiketleyebilirsiniz, böylece müşterileriniz yalnızca hizmeti kullanırken markanızı görürler.",
        connected_apps: "MCP üzerinden bağladığınız uygulamalar burada görünecektir.",
        connector: "{brand} ile binlerce uygulamadan müşterilerinizi içe aktarın.",
        customer_messages: "Mesajları planlamak için bir değerlendirme isteyin.",
        customer_reviews: "Bu müşteriden bir değerlendirme isteyin.",
        customers: "Müşterilerinizi içe aktararak değerlendirmeler istemeye başlayabilirsiniz.",
        external_links: "Hizmetlerinizi satmanıza yardımcı olması için müşteri portalınıza harici bağlantılar ekleyin. Bu bağlantılar müşterilerinize kenar çubuğunda gösterilecektir.",
        links: "Sayfanıza 3. parti web sitelerinde yorum bırakmanızı sağlayacak butonlar ekleyin.",
        locations: "Yorumları birden fazla konuma bağlayabilmeniz için bir konum oluşturun.",
        ltd: "Erişim kodunuzla ömür boyu erişimin kilidini açın. Her kod sınırlı sayıda aylık istek ve tüm özelliklerle birlikte gelir. Kodlar istiflenebilir. 3 veya daha fazla kod ajans planının kilidini açar. Erişim kodlarınızı aşağıya girin.",
        mcp_example_prompts: "MCP sunucu bağlandıktan sonra, başlangıç noktası olarak bunları asistanınıza yapıştırın.",
        messages: "Müşterilerinizden yorum istendiğinde her istek ve hatırlatma burada gösterilecektir.",
        no_commissions: "Henüz herhangi bir komisyon kazanmadınız.",
        no_payouts: "Onaylanmış bakiyeniz en az 50,00 ABD dolarına ulaştığında ve banka hesabınız bağlandığında ödemeler manuel olarak gönderilir.",
        no_projects: "Henüz bir projeye atanmadınız. Erişim için yöneticinizle iletişime geçin.",
        no_referrals: "Henüz kimseyi yönlendirmediniz. Başlamak için yönlendirme bağlantınızı paylaşın.",
        qr_codes: "Özel renkler, konumlar ve etiketler QR kodları oluşturun. SVG veya PNG olarak indirin.",
        referrals_share_subject: "Yapay Zeka İtibar Yöneticim",
        referrals_share_text: "İşletme değerlendirmeleri almak için gizli silahım: More Good Reviews. Gerçekten işe yarayan yapay zeka destekli itibar yönetimi. Bağlantımla kaydolun:",
        review_pages: "Projeniz müşterilerinizin yorum bırakması için birden fazla yorum sayfasına sahip olabilir. Bu, birden fazla lokasyona sahip işletmeler için faydalıdır.",
        reviews: "Müşterilerinizden değerlendirmeler bekliyoruz.",
        showcase: "Daha yeni başlıyoruz.",
        signatures: "E-posta uygulamanıza kopyalayıp yapıştırabileceğiniz bir e-posta imzası oluşturun.",
        sources: "Yorumlarınızı kategorilere ayırabileceğiniz bir kaynak oluşturun.",
        tag_rules: "Yorumlarınızı yapay zeka ile otomatik olarak kategorilere ayırmak için bir kural oluşturun.",
        tags: "Değerlendirmelerinizi ve müşterilerinizi kategorize etmek için bir etiket oluşturun.",
        unauthorized: "Bu sayfaya erişim yetkiniz yok.",
        unsubscribed: "Artık değerlendirme isteklerine aboneliğiniz sona erdi.",
        webhooks: "Platform etkinlikleri hakkında bildirim almak için webhooks ekleyin.",
        widgets: "Yorumları web sitenize yerleştirmek için widget'lar oluşturun.",
        your_referral_link_text: "Bağlantınızı paylaşarak, referans verdiğiniz müşterilerden gelen her ödeme için %{rate} tekrarlayan komisyon kazanın. Onaylanmış bakiyeniz en az 50,00 ABD dolarına ulaştığında ödemeler manuel olarak gönderilir."
    },
    notification_types: {
        descriptions: {
            imports: "İçe aktarma işlemleri tamamlandığında gönderilir.",
            new_reviews: "değerlendirmeler alındığında gönderilir.",
            sent_replies: "değerlendirmeler otomatik olarak yanıt verildiğinde gönderilir.",
            weekly_reports: "Faaliyet özeti haftalık olarak gönderilir."
        },
        names: {
            imports: "İçe aktarmalar",
            new_reviews: "Yeni Değerlendirmeler",
            sent_replies: "Gönderilen Yanıtlar",
            weekly_reports: "Haftalık Raporlar"
        }
    },
    roles: {
        manager: "Müdür",
        operator: "Operatör",
        owner: "Sahip",
        super_admin: "Yönetici",
        viewer: "Görüntüleyici"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Daveti Kabul Et",
        accepting_invite: "Daveti Kabul Etme",
        access_denied: "Erişim engellendi",
        account: "Hesap",
        actions: "Eylemler",
        add_custom_field: "Özel Alan Ekle",
        add_ons: "Eklentiler",
        address: "Adres",
        agencies: "Acenteler",
        agency: "Acente",
        ai: "Yapay zeka",
        ai_assistant: "AI Asistanı",
        ai_highlights: "Yapay Zeka Öne Çıkan Noktaları",
        ai_replies: "AI Cevapları",
        ai_review_suggestions: "AI Değerlendirme Önerileri",
        analytics: "Analitik",
        api: "API",
        api_key: "API Anahtarı",
        appearance: "Dış görünüş",
        application_connectors: "Uygulama Bağlayıcıları",
        attributes: "Nitelikler",
        authorize: "Yetkilendirmek",
        auto_tagging: "Otomatik Etiketleme",
        automatic_review_collection: "Otomatik Değerlendirme Toplama",
        billing: "Faturalama",
        branding: "Markalaşma",
        change_password: "Şifre değiştir",
        clients: "Müşteriler",
        cname: "CNAME",
        conditions: "Koşullar",
        confirmation_message: "Onay Mesajı",
        connected_apps: "Bağlı Uygulamalar",
        contact_us: "Bize Ulaşın",
        cookie_policy: "Çerez Politikası",
        cookie_preferences: "Çerez Tercihleri",
        copy: "Kopyala",
        create_your_account: "Hesabınızı Oluşturun",
        crms: "CRM'ler",
        css: "CSS",
        custom_field: "Özel Alan",
        custom_fields: "Özel Alanlar",
        custom_icons: "Özel Simgeler",
        customer: "Müşteri",
        customer_facing_pages: "Müşteriye Yönelik Sayfalar",
        customers: "Müşteriler",
        dashboard: "Kontrol paneli",
        details: "Detaylar",
        dmarc: "DMARC",
        domain: "Alan adı",
        dpa: "Veri İşleme Sözleşmesi",
        dsar: "Veri Sahibine Erişim Talebi",
        email_address: "E-posta Adresi",
        email_messages: "E-posta Mesajları",
        email_settings: "E-posta Ayarları",
        email_usage: "E-posta Kullanımı",
        emails: "E-postalar",
        embed_code: "Gömülü Kod",
        examples: "Örnekler",
        export: "Dışa aktarma",
        external_link: "Dış Bağlantı",
        external_link_num: "Dış Bağlantı #{num}",
        external_links: "Dış Bağlantılar",
        field: "Alan",
        fields: "Alanlar",
        filters: "Filtreler",
        form_fields: "Form Alanları",
        got_access_code: "Erişim Kodunuz mu var?",
        hipaa: "HIPAA Bildirimi",
        how_it_works: "Nasıl Çalışır",
        incentive: "Teşvik",
        instructions: "Talimatlar",
        integration: "Entegrasyon",
        integrations: "Entegrasyonlar",
        javascript: "JavaScript",
        latest_reviews: "Son Değerlendirmeler",
        lifetime_deal: "Ömür boyu anlaşma",
        limits: "Sınırlar",
        link: "Bağlantı",
        links: "Bağlantılar",
        location: "Konum",
        location_picker: "Konum Seçici",
        locations: "Konumlar",
        log_in: "Giriş yapmak",
        log_out: "Çıkış Yap",
        make_default: "Varsayılan Yap",
        manage_limits: "Sınırları Yönet",
        manage_overrides: "Geçersiz Kılmaları Yönet",
        manage_review: "Değerlendirme Yönet",
        mcp_example_prompts: "Örnek İstemler",
        mcp_server: "MCP Sunucu",
        message: "Mesaj",
        messages: "Mesajlar",
        meta: "Meta",
        no_clients: "Client Yok",
        no_commissions: "Komisyon Yok",
        no_connected_apps: "Bağlı Uygulama Yok",
        no_custom_fields: "Özel Alan Yok",
        no_customers: "Müşteri Yok",
        no_links: "Bağlantılar Yok",
        no_locations: "Konum Yok",
        no_members: "Üye Yok",
        no_messages: "Mesaj Yok",
        no_payouts: "Ödeme Yok",
        no_projects: "Proje Yok",
        no_qr_codes: "QR kodları yok",
        no_referrals: "Yönlendirme Yok",
        no_review_pages: "Değerlendirme sayfaları Yok",
        no_reviews: "Değerlendirmeler Yok",
        no_tags: "Etiketler Yok",
        no_team_members: "Takım Üyesi Yok",
        no_template: "Şablon Yok",
        no_widgets: "Widget Yok",
        notifications: "Bildirimler",
        options: "Seçenekler",
        overview: "Genel Bakış",
        payment_method: "Ödeme yöntemi",
        photo: "Fotoğraf",
        plans: "Planlar",
        powered_by: "Tarafından desteklenmektedir",
        pricing: "Fiyatlandırma",
        privacy_policy: "Gizlilik Politikası",
        profile: "Profil",
        project: "Proje",
        project_limits: "Proje Sınırları",
        project_overrides: "Proje Geçersiz Kılma",
        projects: "Projeler",
        qr_code: "QR Kodu",
        qr_codes: "QR Kodları",
        ratings: "Derecelendirmeler",
        redeem_access_code: "Erişim Kodunu Kullan",
        redirecting: "Yönlendiriliyor",
        redirects: "Yönlendirmeler",
        referrals_commissions: "Komisyonlar",
        referrals_payouts: "Ödemeler",
        referral_program: "Referans Programı Şartları",
        reminders: "Hatırlatmalar",
        reply: "Cevap vermek",
        request: "İstek",
        request_options: "İstek Seçenekleri",
        requests: "İstekler",
        required: "Gerekli",
        reschedule_message: "Mesajı Yeniden Planla",
        reset_password: "Şifreyi Sıfırla",
        retries: "Yeniden denemeler",
        review: "Değerlendirme",
        review_link: "Değerlendirme Bağlantı",
        review_page: "Değerlendirme sayfası",
        review_pages: "Değerlendirme sayfaları",
        review_spotlight: "Öne çıkan değerlendirme",
        review_suggestions: "Önerileri Değerlendirme",
        review_wall: "Değerlendirme duvarı",
        reviewer: "Değerlendiren",
        reviews: "Değerlendirmeler",
        save_changes: "Değişiklikleri Kaydet",
        schedule: "Takvim",
        scrape_a_website: "Bir web sitesinden çek",
        search_engines: "Arama Motorları",
        sections: "Bölümler",
        select_csv_file: "CSV Dosyasını Seçin",
        select_project: "Proje seç",
        selecting_project: "Proje Seçimi",
        sending_domain: "Alan Adı Gönderiliyor",
        sending_limits: "Gönderim Sınırları",
        settings: "Ayarlar",
        setup: "Kurmak",
        setup_basics: "İstek Stratejiniz",
        setup_business: "Hadi Başlayalım",
        setup_google: "Google İşletme Profiliniz",
        setup_trusted: "5.000'den fazla işletme tarafından güvenilen bir marka.",
        showcase: "Showcase",
        sign_up: "Üye olmak",
        signature: "İmza",
        signatures: "İmzalar",
        signing_in: "Oturum açma",
        single_sign_on: "Tek oturum açma",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "SMS Mesajları",
        sms_usage: "SMS Kullanımı",
        smtp_configuration: "SMTP Yapılandırması",
        source: "Kaynak",
        sources: "Kaynaklar",
        space: "Çalışma alanı",
        spaces: "Çalışma alanları",
        stats: "İstatistikler",
        sub_processors: "Alt işlemciler",
        success_page: "Başarı Sayfası",
        summary: "Özet",
        tag: "Etiket",
        tag_rule: "Etiket Kuralı",
        tags: "Etiketler",
        team_members: "Takım Üyeleri",
        template: "Şablon",
        templates: "Şablonlar",
        terms_of_service: "Hizmet Şartları",
        two_factor_authentication: "İki Faktörlü Kimlik Doğrulama",
        unable_to_complete_request: "İstek Tamamlanamadı",
        unique_review_link: "Benzersiz Değerlendirme Bağlantı",
        unsent_messages: "Gönderilmemiş Mesajlar",
        unsubscribe: "Abonelikten çık",
        update_plan: "Güncelleme Planı",
        usage: "Kullanım",
        user: "Kullanıcı",
        user_info: "Kullanıcı Bilgileri",
        verify_email_address: "E-posta Adresini Doğrula",
        verifying_email: "E-posta Doğrulanıyor",
        visibility: "Görünürlük",
        webhook: "Web kancası",
        webhooks: "Web kancaları",
        website: "Web sitesi",
        white_label_api: "Beyaz Etiket API",
        white_label_client_portal: "Beyaz Etiket Client Portalı",
        white_label_image_urls: "Beyaz Etiketli Resim URL'leri",
        white_label_sending_domain: "Beyaz Etiket Gönderme Alanı",
        white_label_widget_tag: "Beyaz Etiket Widget Etiketi",
        widget: "Widget",
        widget_num: "#{num} adlı araç",
        widgets: "Widget'lar",
        your_plan: "Planınız"
    },
    tones: {
        apologetic: "Özür dileyen",
        casual: "Gündelik",
        empathetic: "Empatik",
        enthusiastic: "Hevesli",
        formal: "Resmi",
        friendly: "Arkadaşça",
        grateful: "Minnettar",
        humorous: "Mizah",
        informative: "Bilgilendirici"
    },
    widgets: {
        labels: {
            alignment: "Hizalama",
            animation: "Animasyon",
            autoplay: "Otomatik oynatma",
            autoplay_delay: "Otomatik Oynatma Gecikmesi",
            avatar: "Avatar",
            background_color: "Arkaplan Rengi",
            border: "Sınır",
            border_color: "Sınır Rengi",
            border_radius: "Sınır Yarıçapı",
            border_width: "Sınır Genişliği",
            carousel: "Carousel",
            colors: "Renkler",
            company: "Şirket",
            customer: "Müşteri",
            customer_position: "Müşteri Pozisyonu",
            date: "Tarih",
            delay: "Gecikme",
            drop_shadow: "Düşen Gölge",
            duration: "Süre",
            filters: "Filtreler",
            font: "Yazı tipi",
            font_emphasis: "Yazı Tipi Vurgusu",
            font_family: "Yazı Tipi Ailesi",
            font_size: "Yazı Tipi Boyutu",
            include_hidden: "Gizli Değerlendirmeler Dahil Et",
            layout: "Düzen",
            limit: "Sayfa Başına Değerlendirmeler",
            location_ids: "Konumlar",
            marquee: "Marquee",
            max_slides: "Maksimum Slaytlar",
            max_width: "Maksimum Genişlik",
            name_convention: "İsim",
            padding: "İç boşluk",
            pagination: "Sayfalandırma",
            quotes: "Alıntılar",
            rating: "Puan",
            rating_round: "Yuvarlama",
            rating_round_hundredth: "En yakın yüzde bir (4,94)",
            rating_round_tenth: "En yakın onda bir (4,9)",
            review: "Değerlendirme",
            review_chars: "Değerlendirme Uzunluğu",
            review_count: "Değerlendirme Sayısı",
            review_id: "Değerlendirme",
            review_ids: "Değerlendirmeler",
            review_ids_for_faces: "Faces için Değerlendirmeler",
            reviews: "Değerlendirmeler",
            schema: "Şema",
            schema_name: "İşletme Adı",
            schema_type: "İşletme Türü",
            score: "En Düşük Puan",
            show_on_mobile: "Mobil Cihazda Göster",
            slider: "Kaydırıcı",
            source: "Kaynak",
            source_ids: "Kaynaklar",
            source_position: "Kaynak Pozisyonu",
            speed: "Hız",
            star_color: "Yıldız Rengi",
            star_display: "Yıldız Gösterimi",
            star_size: "Yıldız Boyutu",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Etiketler",
            take: "Maksimum Değerlendirmeler Sayısı",
            text_color: "Metin Rengi",
            truncate: "Kısaltılmış Değerlendirme",
            visible_slides: "Görünür Slaytlar",
            width: "Genişlik"
        },
        types: {
            badge: "Rozet",
            carousel: "Carousel",
            carousel_dynamic: "Dinamik Atlıkarınca",
            corner: "Köşe",
            corner_dynamic: "Dinamik Köşe",
            faces: "Yüzler",
            headline: "Başlık",
            highlights: "Önemli Noktalar",
            marquee: "Marquee",
            spotlight: "Öne çıkan",
            wall: "Duvar"
        }
    }
}
